<template>
    <div class="card">
        <tabs v-model="selectedTab">
            <tab class="tab" v-for="(tab, i) in tabs" :key="`t${i}`" :val="tab" :label="tab" :indicator="true"
                style="font-size: 13px;" :class="{ active: i === selectedTab , inactive: i != selectedTab }">
                {{ tab }}
            </tab>
        </tabs>
       
        <tab-panels v-model="selectedTab" :animate="true">
            <tab-panel style="height:100%">
                <loading :active="isLoadingModel" :can-cancel="true" color="#173EA3" :is-full-page="fullPage"></loading>
                <!-- <div v-if="selectedTab == 'SBM Dashboard'" style="margin-top:20px;height:100%">
                    <superset_dashboard :client_id="client_id_local" :user_id="user_id" :superset_id="superset_id" v-if="superset_id"></superset_dashboard>
                </div>
                <div v-if="selectedTab == 'Individual/Place Visits'" style="margin-top:20px;height:100%">
                    <superset_dashboard :client_id="client_id_local" :user_id="user_id" :superset_id="superset_id" v-if="superset_id"></superset_dashboard>
                </div>
                <div v-if="selectedTab == 'Vehicles Summary'" style="margin-top:20px;height:100%">
                    <superset_dashboard  :superset_id="superset_id" v-if="superset_id"></superset_dashboard>
                </div>
                <div v-if="selectedTab == 'Dumping Ground'" style="margin-top:20px;height:100%">
                    <superset_dashboard  :superset_id="superset_id" v-if="superset_id"></superset_dashboard>
                </div>
                <div v-if="selectedTab == 'Top/Bottom Performers'" style="margin-top:20px;height:100%">
                    <superset_dashboard  :superset_id="superset_id" v-if="superset_id"></superset_dashboard>
                </div>
                <div v-if="selectedTab == '30 Days Analysis'" style="margin-top:20px;height:100%">
                    <superset_dashboard  :superset_id="superset_id" v-if="superset_id"></superset_dashboard>
                </div> -->
                <!-- <div v-if="selectedTab == 'Dashboard'" style="margin-top:20px;height:100%;">
                    <div class="grid">
                        <div class="col-12 xl:col-12">
                            <div class="card" style="background-color: #D5ECFC;height:100%">
                                <div class="grid">
                                    <div class="col-3">
                                        <span class="p-float-label">
                                            <Dropdown style="width:100%" id="state" v-model="district_id_search" filter
                                                :options="district_dropdown" optionLabel="name" :optionValue="value">
                                            </Dropdown>
                                            <label>District</label>
                                        </span>
                                    </div>
                                    <div class="col-3">
                                        <span class="p-float-label">
                                            <Dropdown style="width:100%" id="state" v-model="taluka_id_search" filter
                                                :options="taluka_dropdown" optionLabel="name" :optionValue="value">
                                            </Dropdown>
                                            <label>Taluka</label>
                                        </span>
                                    </div>
                                    <div class="col-3">
                                        <span class="p-float-label">
                                            <Dropdown style="width:100%" id="state" v-model="village_id_search" filter
                                                :options="village_dropdown" optionLabel="name" :optionValue="value">
                                            </Dropdown>
                                            <label>Village</label>
                                        </span>
                                    </div>
                                    <div class="col-3">
                                        <span class="p-float-label">
                                            <Dropdown style="width:100%" id="state" v-model="block_id_search" filter
                                                :options="block_dropdown" optionLabel="name" :optionValue="value">
                                            </Dropdown>
                                            <label>Block</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="col-12 xl:col-6">
                            <div class="card" style="background-color: #D5ECFC;height:100%">
                                <div class="grid">
                                    <div class="col-6">
                                        <b>
                                            <center>Ticket Count</center>
                                        </b>
                                        <hr>
                                        <center>
                                            <Chart type="doughnut" :data="chartData_doughnut"
                                                :options="chartOptions_doughnut" class="w-full md:w-15rem" />
                                        </center>
                                        <b>
                                            <center style="margin-top:10px">Total Tickets : 6202</center>
                                        </b>
                                    </div>
                                    <div class="col-6">
                                        <div class="row" style="margin-top: 10%;">
                                            <b>
                                                <center>Completed Tickets</center>
                                            </b>
                                            <b>
                                                <center>
                                                    <h3>2540</h3>
                                                </center>
                                            </b>
                                        </div>&nbsp;
                                        <div class="row" style="margin-top: 10%;">
                                            <b>
                                                <center>In-Progress Tickets</center>
                                            </b>
                                            <b>
                                                <center>
                                                    <h3>1540</h3>
                                                </center>
                                            </b>
                                        </div>&nbsp;
                                        <div class="row" style="margin-top: 10%;">
                                            <b>
                                                <center>Not Started Tickets</center>
                                            </b>
                                            <b>
                                                <center>
                                                    <h3>2122</h3>
                                                </center>
                                            </b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 xl:col-6">
                            <div class="card" style="background-color: #D5ECFC;height:100%" @click="toggleZoom">
                                <center>
                                    <b>Pending Ticket's By Days</b>
                                    <hr>
                                    <Chart type="bar" :data="chartData" :options="chartOptions" class="h-20rem" />
                                    <b>Pending For Days</b>
                                </center>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- <div v-if="selectedTab == 'Vehicles Visits'" style="margin-top:20px;">
                    <gps    :vehicle_dropdownItems="vehicle_dropdownItems" 
                            :routeitems="routeitems" 
                            :client_id_dropdown="client_id_dropdown"
                            :user_key="user_key"
                            :client_group_ids="client_group_ids"
                            v-if="superset_id"></gps>
                </div> -->
                <!-- <div v-if="selectedTab == 'Vehicles Visits_old'" style="margin-top:20px;">
                    <Toast />
                     <div class="col-12">
                    <div class="p-fluid formgrid grid">
                                <div class="field col-12 md:col-2">
                                    <span class="p-float-label">
                                        <Calendar
                                                v-model="vehicle_from_date"
                                                dateFormat="dd-mm-yy"
                                                selectionMode="range"
                                                :manualInput="false"
                                                :numberOfMonths="3"
                                                :showTime="false"
                                                hourFormat="12"
                                                />
                                        <label>Date</label>
                                        </span>
                                </div>
                                <div class="field col-12 md:col-2">
                                    <span class="p-float-label">
                                        <InputText  format="number"  v-model="reg_number"  > </InputText>
                                        <label>Vehicle Number</label>
                                        </span>
                                </div>
                                <div class="field col-12 md:col-2">
                                    <span class="p-float-label">
                                        <MultiSelect       
                                            id="User" 
                                            filter
                                            display="chip"
                                            v-model="vehicle_dropdownItem" 
                                            :options="vehicle_dropdownItems" 
                                            optionLabel="name"
                                            :maxSelectedLabels="2"
                                        >
                                        </MultiSelect>
                                        <label>Vehicle Type</label>
                                        </span>
                                </div>
                                <div class="field col-12 md:col-2" v-if="user_key && (client_group_ids)">
                                    <span class="p-float-label">
                                        <MultiSelect  
                                        id="state" filter 
                                        display="chip"
                                        v-model="client_id_search"  
                                        :options="client_id_dropdown" 
                                        optionLabel="name" 
                                        @change="route_list"
                                        :maxSelectedLabels="2"
                                        :optionValue="value"></MultiSelect>
                                        <label for="client">Select Client</label>
                                    </span>
                                </div>
                                <div class="field col-12 md:col-2">
                                    <span class="p-float-label">
                                        <MultiSelect 
                                            id="status" 
                                            filter 
                                            v-model="routeitem_multiselect" 
                                            display="chip"
                                            :options="routeitems"
                                            :value="routeitems.value" 
                                            optionLabel="name"
                                            required="true"
                                            :maxSelectedLabels="2"
                                            ></MultiSelect>
                                        <label>Select Route</label>
                                        </span>
                                </div>
                                <div class="field col-12 md:col-2">
                                    <Button
                                    icon="pi pi-search"
                                    v-tooltip.bottom="'Search'"
                                    @click="get_dashboard_vehicle_list(2)"
                                    />&nbsp;
                                    <Button icon="pi pi-refresh" @click="reset"
                             />
                                </div>
                            </div>
                        </div>
                            <div class="p-fluid formgrid grid">
                            </div>
                    <div class="grid">
                        <div class="col-12 xl:col-6">
                            <DataTable 
                            :loading="loading"
                            ref="dt10" 
                            :value="vehicle_data" 
                            class="p-datatable-sm" 
                            :rows="10"
                            v-model:selection="selectedProduct"
                            selectionMode="single"
                            :metaKeySelection="true"
                            @rowSelect="onRowSelect" 
                            removableSort 
                            responsiveLayout="scroll" 
                            style="font-size: 12px" 
                            :paginator="true" 
                            dataKey="sr_no"
                            :rowHover="true" 
                            showGridlines>
                                    <template #header>
                                        <div
                                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                            <h5 class="m-0">Vehicle Running Summary</h5>
                                            <Button type="button" icon="pi pi-refresh" text @click="reset()"  />
                                        </div><div style="text-align:right;font-weight:bold"><span>Total :</span>{{vehicle_data.length}}</div>
                                    </template>
                                    <template #empty> No Record found. </template>
                                    <Column field="vehicle_type" header="Vehicle Type" sortable >
                                        <template #body="{ data }">
                                            <span>{{ data.vehicle_type }}</span>
                                        </template>
                                    </Column>
                                    <Column field="vehicle_number" header="Vehicle Number" sortable style="min-width: 10rem">
                                        <template #body="{ data }">
                                            <span style="color: blue;"><u>{{ data.vehicle_number }}</u></span>
                                        </template>
                                    </Column>
                                    <Column field="date" header="Date" sortable style="min-width: 6rem">
                                        <template #body="{ data }">
                                            <span v-if="data.date">{{ dateFormatDMY(data.date) }}</span>
                                            <span v-else>-</span>
                                        </template>
                                    </Column>
                                    <Column field="Ride_Duration" sortable header="Ride Duration (hrs)">
                                        <template #body="{ data }">
                                            <span>{{ data['Ride Duration (hrs)'] }}</span>
                                        </template>
                                    </Column>
                                    <Column field="Distance_Travelled" sortable header="Distance Travelled (km)" >
                                        <template #body="{ data }">
                                            <span>{{ data['Distance Travelled (km)'] }}</span>
                                        </template>
                                    </Column>
                                    <Column field="Routes_Covered" sortable header="Routes Covered" >
                                        <template #body="{ data }">
                                            <span>{{ data['Routes Covered'] }}</span>
                                        </template>
                                    </Column>
                                </DataTable>
                        </div>
                        <div class="col-12 xl:col-6">
                            <DataTable 
                            v-model:selection="selectedProduct"
                            :loading="set_loading"
                            ref="dt12" 
                            :value="search_vehicle_data" 
                            class="p-datatable-sm" 
                            :rows="10"
                            responsiveLayout="scroll" 
                            style="font-size: 12px" 
                            :paginator="true" 
                            dataKey="_id"
                            :rowHover="true" 
                            removableSort
                            showGridlines>
                                    <template #header>
                                        <div
                                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                            <h5 class="m-0">Ride Route Details</h5>
                                            <Button type="button" icon="pi pi-refresh" text @click="reset()"  />
                                        </div><div style="text-align:right;font-weight:bold"><span>Total :</span>{{search_vehicle_data.length}}</div>
                                    </template>
                                    <template #empty> No Record found. </template>
                                    <Column header="Map" headerStyle="min-width:2rem;" style="text-align: center;">
              <template #body="slotProps">
                <Button
                type="button"
                  icon="pi pi-map-marker"
                  v-tooltip.bottom="'View Map'"
                  text
                  @click="view_Map(slotProps.data)"
                />
              </template>
            </Column>
                                    <Column field="vehicle_type" sortable header="Vehicle Type " style="">
                                        <template #body="{ data }">
                                            <span>{{ data.vehicle_type }}</span>
                                        </template>
                                    </Column>
                                    <Column field="vehicle_number" sortable header="Vehicle Number" style="min-width: 10rem" >
                                        <template #body="{ data }">
                                            <span>{{ data.vehicle_number }}</span>
                                        </template>
                                    </Column>
                                    <Column field="date" header="Date" sortable style="min-width: 7rem">
                                        <template #body="{ data }">
                                            <span v-if="data.date">{{ dateFormatDMY(data.date) }}</span>
                                            <span v-else>-</span>
                                        </template>
                                    </Column>
                                    <Column field="Ride_Duration" sortable header="Ride Duration (hrs)">
                                        <template #body="{ data }">
                                            <span>{{ data['Ride Duration (hrs)'] }}</span>
                                        </template>
                                    </Column>
                                    <Column field="Distance_Travelled" sortable header="Distance Travelled (km)">
                                        <template #body="{ data }">
                                            <span>{{ data['Distance Travelled (km)'] }}</span>
                                        </template>
                                    </Column>
                                    <Column field="route_name" sortable header="Route Name">
                                        <template #body="{ data }">
                                            <span>{{ data['route_name'] }}</span>
                                        </template>
                                    </Column>
                                </DataTable>
                        </div>   
                </div>
</div>           -->
<div v-if="selectedTab == 'Gallery'" style="margin-top:10px;">
    <Track_Gallary @submit="Gallery_OnSubmit"></Track_Gallary>
</div>
<div v-if="selectedTab == 'SUMMARY'" style="margin-top:10px;">
    <Track_Summary @submit="summary_OnSubmit"></Track_Summary>
</div>
                <div v-if="selectedTab == 'Track Report'" style="margin-top:10px;">
                    <Sidebar v-model:visible="track_ride_productDialog" :baseZIndex="1000" position="full">
                    <div class="grid p-fluid"> 
                        <div class="col-12  md:col-9">
                            <div class="card">
                            
                                <img v-if="list_loader === true" src="images/loader.gif" alt="Loading"
                                    style="width: 100%;height: 500px" />
                                <GoogleMap v-else api-key="AIzaSyC-8ib8PMibUDDYoj5kzRzKwcusvw3Gztc"
                                    style="width: 100%; height: 500px" :center="ride_start" :zoom="15">
                                    <Marker :options="{ position: ride_start, label: 'Ride Start Point' }">
                                    </Marker>
                                    <Marker :options="{ position: ride_end, label: 'Ride End Point' }">
                                    </Marker>
                                    <MarkerCluster>
                                        <Marker :options="{ position: marker, title: 'stop', label: marker.stop_name, color: 'green', icon: marker.icon }" v-for="(marker, index) in ride_markers" :key="index" style="width:5px;height:5px">
                                        </Marker>
                                    </MarkerCluster>
                                    <Polyline :options="ride_polypath" />
                                </GoogleMap>
                            </div>
                        </div>
                        <div class="col-12 md:col-3">
                    <div class="grid">
                        <div class="col-12 lg:col-6 xl:col-12">
                            <Fieldset legend="Ride Details" :toggleable="true" :collapsed="false"
                                style="background-color: #22C55E;">
                                <div class="flex justify-content-between mb-1">
                                    <div>
                                        <span class="block  font-medium mb-2" style="color: white !important;">Route : {{
                                            route_name
                                        }}</span>
                                        <span class="block  font-medium mb-2" style="color: white !important;">Distance : {{
                                            total_distance
                                        }}</span>
                                        <span class="block  font-medium mb-2" style="color: white !important;">Time : {{
                                            total_time }}</span>
                                        <span class="block  font-medium mb-2" style="color: white !important;"
                                            v-if="driver_name">Driver Name : {{
                                                driver_name.toUpperCase() }}</span>
                                        <span class="block  font-medium mb-2" style="color: white !important;"
                                            v-if="driver_mobile_number">Mobile
                                            Number : {{ driver_mobile_number }}</span>
                                        <span class="block  font-medium mb-2" style="color: white !important;"
                                            v-if="vehicle_registration_number">Vehicle No : {{ vehicle_registration_number
                                            }}</span>
                                        <span class="block  font-medium mb-2" style="color: white !important;"
                                            v-if="vehicle_type">Vehicle Type :
                                            {{ vehicle_type }}</span>
                                    </div>
                                </div>
                            </Fieldset>
                        </div>
                    </div>
                </div>
            </div>
                    </Sidebar>
                    <Sidebar v-model:visible="stop_location_productDialog" :baseZIndex="1000" position="full">
                        <div class="col-12">
                            <div class="card">
                                <GoogleMap api-key="AIzaSyC-8ib8PMibUDDYoj5kzRzKwcusvw3Gztc"
                                    style="width: 100%; height: 500px" :center="stop_point" :zoom="15">
                                    <Marker :options="{ position: stop_point, label: stop_point_label }">
                                    </Marker>
                                </GoogleMap>
                            </div>
                        </div>
                    </Sidebar>
                    <div class="col-12 lg:col-6 lg:col-12">
                        <InputText type="text" placeholder="PAC ID" v-model="pac_id">
                        </InputText>&nbsp;
                        <InputText type="text" placeholder="Mobile No" v-model="mob_id">
                        </InputText>&nbsp;
                        <InputText type="text" placeholder="Stop Name" v-model="stop_name">
                        </InputText>&nbsp;
                        <Dropdown filter id="state" v-model="delivery_status" :options="delivery_status_options"
                            optionLabel="name" placeholder="Delivery Status" style="width:180px" :optionValue="value">
                        </Dropdown>&nbsp;
                        <Dropdown filter id="state" v-model="installation_status" :options="installation_status_options"
                            optionLabel="name" placeholder="Installation Status" style="width:180px" :optionValue="value">
                        </Dropdown>&nbsp;
                        <MultiSelect id="district" filter v-model="district_dropdownItem" :options="district_dropdownItems"
                            placeholder="Select District" style="width:180px" optionLabel="name" display="chip"
                            @change="getBlockData(2)">
                        </MultiSelect>&nbsp;
                        <MultiSelect id="block" filter v-model="block_dropdownItem" :options="block_dropdownItems"
                            placeholder="Select Block" style="width:180px" optionLabel="name" display="chip"
                            @change="get_village(1)">
                        </MultiSelect>&nbsp;
                        <MultiSelect v-model="village_dropdownItem" :options="village_dropdownItems"
                            placeholder="Select village" optionLabel="name" filter style="width:180px" display="chip"
                            :maxSelectedLabels="3" @filter="get_village">
                        </MultiSelect>&nbsp;
                        <!-- <MultiSelect id="panchayat" filter v-model="panchayat_dropdownItem" :options="panchayat_dropdownItems" placeholder="Select Panchyat" style="width:180px"
                    optionLabel="name" @change="getVillageData(1,2)">
                  </MultiSelect> -->
                        <Button icon="pi pi-search" @click="search_track_report_list"
                            class="p-button-rounded p-button-success mt-2" v-tooltip.bottom="'Search'"/>&nbsp;
                        <Button icon="pi pi-refresh" @click="reset_track_report"
                            class="p-button-rounded p-button-success mt-2" v-tooltip.bottom="'Reset'"/>&nbsp;
                        <Button icon="pi pi-download" @click="exportCSV3"
                            class="p-button-rounded p-button-success mt-2" v-tooltip.bottom="'Excel'"/>
                    </div>
                    <!-- <DataTable 
                    ref="track_dt" 
                    v-model:selection="selectedProducts" 
                    :value="report_data"
                    class="p-datatable-sm" 
                    :rows="10" 
                    responsiveLayout="scroll" 
                    style="font-size: 12px"
                    :paginator="true" 
                    dataKey="PACS_id" 
                    :rowHover="true" showGridlines> -->
                   
                    <DataTable
                        class="p-datatable-sm"
                         ref="track_dt"
                        :lazy="true"
                        :loading="track_loading"
                        :totalRecords="total_report_data"
                        :paginator="true"
                        :value="report_data"
                        v-model:selection="selectedProducts"
                        dataKey="PACS_id"
                        :rows="10"
                        :filters="filters"
                        @page="onPage($event)"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        :rowsPerPageOptions="[5, 10, 30,50,100,200,300,400,500, total_report_data]"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        responsiveLayout="scroll"
                        style="font-size: 12px"
                        :rowHover="true" showGridlines
                    >
                        <template #header>
                            <div key=""
                                class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                <b class="m-0">Track Report</b>
                                
                            </div>
                           
                            <div style="text-align: right; font-weight: bold">
                                <span>Total :</span>{{ total_report_data }}
                               
                                
                            </div>
                            <div style="text-align: left;">
                                <Button :disabled="selectedProducts.length == 0" label="Print DC" size="small"
                                    severity="warning" raised @click="Print_DC_selected()"
                                    v-tooltip.bottom="'Print Delivery Challan'" /> &nbsp;
                                    <Button :disabled="selectedProducts.length == 0" label="Print IR" size="small"
                                    severity="warning" raised @click="Print_IR_selected()"
                                    v-tooltip.bottom="'Print Installation Report'" />
                            </div>
                        </template>
                        <template #empty> No Record found. </template>
                        <Column selectionMode="multiple" headerStyle="width: 3rem">
                        </Column>
                        <Column field="PACS_id" header="PACS ID" sortable style="min-width: 3rem">
                            <template #body="{ data }">
                                <span>{{ data.PACS_id }}</span>
                            </template>
                        </Column>
                        <Column field="stop_name" header="Stop" sortable style="min-width: 15rem">
                            <template #body="{ data }">
                                <span>{{ data.stop_name }}</span>
                            </template>
                        </Column>
                        <Column field="delivery_status" header="Delivery Status" sortable style="min-width: 3rem">
                            <template #body="{ data }">
                                <span>{{ data.delivery_status }}</span>
                            </template>
                        </Column>
                        <Column field="installation_status" header="Installation Status" sortable style="min-width: 3rem">
                            <template #body="{ data }">
                                <span>{{ data.installation_status }}</span>
                            </template>
                        </Column>
                        
                        <Column field="district_name" header="District" sortable style="min-width: 10rem">
                            <template #body="{ data }">
                                <span>{{ data.district_name }}-{{ data.district_id }}</span>
                            </template>
                        </Column>
                        <Column field="block_name" header="Block" sortable style="min-width: 10rem">
                            <template #body="{ data }">
                                <span>{{ data.block_name }}-{{ data.block_id }}</span>
                            </template>
                        </Column>
                        <Column field="contact_person_name" header="Contact Person" sortable style="min-width: 15rem">
                            <template #body="{ data }">
                                <span>{{ data.contact_person_name }}</span>
                            </template>
                        </Column>
                        <Column field="mobile_no" header="Mobile" sortable style="min-width: 10rem">
                            <template #body="{ data }">
                                <span>{{ data.mobile_no }}</span>
                            </template>
                        </Column>
                        <Column field="sr_no" header="Challan No" sortable style="min-width: 5rem">
                            <template #body="{ data }">
                                <span>{{ data.sr_no }}</span>
                            </template>
                        </Column>
                        <Column field="visited_date" header="Delivery Date" sortable style="min-width: 3rem">
                            <template #body="{ data }">
                                <span v-if="data.visited_date">{{ dateFormatDMY(data.visited_date) }}</span>
                                <span v-else>-</span>
                            </template>
                        </Column>
                        <Column field="photo" header="Receipt" sortable style="min-width: 15rem">
                            <template #body="{ data }">
                                <span v-if="data.photo" @click="download_receipt(data.photo)">
                                    <Image :src="'https://travelsafe-docs.s3.ap-south-1.amazonaws.com/'+data.photo" alt="Image" width="50" preview   />        
                                </span>
                                <span v-else-if="data.ride_id && data.stop_id">
                                    <!-- <FileUpload
                                        v-tooltip.bottom="'Upload Receipt'"
                                        mode="basic"
                                        id="file_attachment"
                                        ref="file_attachment"
                                        @hange="handleFileUpload"
                                        name="demo[]"
                                        accept="image/*"
                                        :maxFileSize="10000000"
                                        chooseLabel="Upload Receipt"
                                        /> -->

                                        <FileUpload
                                            mode="basic"
                                            name="model[]"
                                            accept="image/*"
                                            :max-file-size="50000000"
                                            :auto="true"
                                            :custom-upload="true"
                                            choose-label="Upload Receipt"
                                            @uploader="handleFileUpload($event,data)"
                                        />
                               </span>
                                <span v-else>-
                                </span>
                            </template>
                        </Column>
                        <Column field="Location" header="Ride" sortable style="min-width: 5rem">
                            <template #body="{ data }">
                                <!-- <Button icon="pi pi-map-marker" size="small" severity="success" raised
                                    @click="track_map(data)" v-tooltip.bottom="'Stop Location'" />
                                &nbsp; -->
                                <Button v-if="data.ride_id" icon="pi pi-car" size="small" severity="warning" raised
                                    @click="view_ride(data)" v-tooltip.bottom="'View Ride'" />
                            </template>
                        </Column>
                    </DataTable>
                    <Dialog v-model:visible="upload_Model" :style="{ width: '900px' }" header="Upload Receipt"
                        :modal="true">
                        <FileUpload name="demo[]" @uploader="onCustomUpload" accept="image/*" :maxFileSize="10000000">
                        <template #empty>
                            <p>Drag and drop files to here to upload.</p>
                        </template>
                        </FileUpload>
                    </Dialog>
                    <Dialog v-model:visible="print_DC_Model" :style="{ width: '900px' }" header="Delivery Chalan"
                        :modal="true">
                        <DeliveryChallan :Printdata="print_delivery_chalan_data" @submit="OnSubmit"></DeliveryChallan>
                    </Dialog>
                    <Dialog v-model:visible="print_IR_Model" :style="{ width: '900px' }" header="IR Chalan"
                        :modal="true">
                        <IRChallan :Printdata="print_delivery_chalan_data" @submit="OnSubmit"></IRChallan>
                    </Dialog>
                </div>
                <div v-if="selectedTab == 'Live Ride Tracking Dashboard'" style="margin-top:20px;">
                    <div class="col-12 lg:col-6 lg:col-12" style="padding:0!important;width:100%;height:700px"
                        v-if="home == true">
                        <InputText type="text" placeholder="Mobile Number" v-model="search_key"
                            v-on:keyup.enter="search_people">
                        </InputText>
                        &nbsp;
                        <InputText type="text" placeholder="name" v-model="name" v-on:keyup.enter="search_people">
                        </InputText>&nbsp;
                        <InputText type="text" placeholder="City" v-model="city" v-on:keyup.enter="search_people">
                        </InputText>&nbsp;
                        <InputText type="text" placeholder="State" v-model="state" v-on:keyup.enter="search_people">
                        </InputText>&nbsp;
                        <InputText type="text" placeholder="Pincode" v-model="pincode" v-on:keyup.enter="search_people">
                        </InputText>&nbsp;
                        <InputText type="text" placeholder="Vehicle Number" v-model="vehicle_number"
                            v-on:keyup.enter="search_people">
                        </InputText>&nbsp;&nbsp;
                        <Dropdown id="status" filter style="width:180px" v-model="routeitem" :options="routeitems"
                            :value="routeitems.value" optionLabel="name" placeholder="Select Route" required="true"
                            @change="search_people"></Dropdown>&nbsp;
                        <Dropdown v-if="user_key && (client_group_ids)" style="width:180px" id="state"
                            v-model="client_id_search" filter placeholder="Select Client" :options="client_id_dropdown"
                            optionLabel="name" :optionValue="value" @change="search_people">
                        </Dropdown>
                        &nbsp;
                        <Button icon="pi pi-search" @click="search_people"
                            class="p-button-rounded p-button-success mt-2" />&nbsp;
                        <Button icon="pi pi-refresh" @click="reset_search_people"
                            class="p-button-rounded p-button-success mt-2" />
                        <div style="text-align:right;font-weight:bold">
                            <Button class="p-button-success" @click="ride_list" type="button" label="Live Rides"
                                icon="pi pi-car" :badge="travellist_filter.length > 0 ? travellist_filter.length : '0'"
                                badgeClass="p-badge-danger" outlined :disabled="travellist_filter.length == 0" />
                        </div>
                        <hr>
                        <GoogleMap api-key="AIzaSyC-8ib8PMibUDDYoj5kzRzKwcusvw3Gztc" style="width: 100%; height: 800px"
                            :center="center" :zoom="5">
                            <MarkerCluster>
                                <Marker v-for="(location, i) in travellist_filter" :options="{ position: location }"
                                    :key="i">
                                    <InfoWindow>
                                        <div id="contet" style="width:450px">
                                            <div id="siteNotice"></div>
                                            <div id="bodyContent" class="grid" style="font-size:11px;width:600px">
                                                <div class="col-3 lg:col-3 lg:col-3">
                                                    <img :src="location.profile_image"
                                                        style="width:100px;border-radius:70%" />
                                                </div>
                                                <div class="col-9 lg:col-9 lg:col-9" style="font-size:15px;">
                                                    
                                                    <b>Driver Name :</b> {{ location.driver_name }}
                                                    <br><b>Driver Mobile Number :</b> {{ location.driver_mobile_number }}
                                                    <br><b>Village Name :</b> {{ location.village_name }}
                                                </div>
                                                <p>
                                                </p>
                                                <p style="width:300px">
                                                </p>
                                                <p>
                                                </p>
                                                <p>
                                                </p>
                                                <Button label="View details" @click="view_details(location)"
                                                    class="p-button-info p-button-sm	 mr-2 mb-2" />
                                            </div>
                                        </div>
                                    </InfoWindow>
                                </Marker>
                            </MarkerCluster>
                        </GoogleMap>
                    </div>
                    <div class="col-12 lg:col-6 xl:col-8" v-if="home == false"
                        style="padding:0!important;width:100%;height:700px">
                        <Button style="text-align-right" label="Back" @click="back_map()"
                            class="p-button-info p-button-sm	 mr-2 mb-2" />
                        <GoogleMapDashboard :center1="center1" :lat="center1.lat" :lng="center1.lng"
                            :centerstart="centerstart" :polyline="polyline" :polypath="polypath" />
                    </div>
                    <Dialog header="Ride Details" v-model:visible="ride_productDialog" :breakpoints="{ '960px': '75vw' }"
                        :style="{ width: '70vw' }" :modal="true">
                        <DataTable ref="ride_dt" :value="travellist_filter" class="p-datatable-sm" :rows="10"
                            responsiveLayout="scroll" style="font-size: 12px" :paginator="true" dataKey="sr_no"
                            :rowHover="true" showGridlines>
                            <template #header>
                                <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                    <h5 class="m-0">Live Ride List</h5>
                                    <Button icon="pi pi-upload" v-tooltip.bottom="'Export'" @click="exportCSV2" />
                                </div>
                                <div style="text-align: right; font-weight: bold">
                                    <span>Total :</span>{{ travellist_filter.length }}
                                </div>
                            </template>
                            <template #empty> No Record found. </template>
                            <Column header="Profile" style="text-align:center;">
                                <template #body="{ data }">
                                    <img :src="data.profile_image" :alt="data.profile_image" v-if="data.profile_image"
                                        class="shadow-2" width="50">
                                    <img v-else
                                        src="https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o="
                                        class="shadow-2" width="50" />
                                </template>
                            </Column>
                            <Column field="vehicle_registrationNumber" header="Vehicle No" sortable style="min-width: 3rem">
                                <template #body="{ data }">
                                    <span>{{ data.vehicle_registrationNumber }}</span>
                                </template>
                            </Column>
                            <Column field="driver_name" header="Driver Name" sortable style="min-width: 3rem">
                                <template #body="{ data }">
                                    <span>{{ data.driver_name }}</span>
                                </template>
                            </Column>
                            <Column field="driver_mobile_number" header="Mobile Number" sortable style="min-width: 3rem">
                                <template #body="{ data }">
                                    <span>{{ data.driver_mobile_number }}</span>
                                </template>
                            </Column>
                            <Column field="village_name" header="Village Name" sortable style="min-width: 3rem">
                                <template #body="{ data }">
                                    <span>{{ data.village_name }}</span>
                                </template>
                            </Column>
                            <Column header="View Details" headerStyle="min-width:5rem;">
                                <template #body="{ data }">
                                    <Button icon="pi pi-eye" v-tooltip.bottom="'View Details'"
                                        class="p-button-rounded p-button-success mr-2" @click="view_details(data)"
                                        size="small" />
                                </template>
                            </Column>
                        </DataTable>
                    </Dialog>
                </div>
            </tab-panel>
        </tab-panels>
        <Sidebar v-model:visible="map_productDialog" :baseZIndex="1000" position="full">
            <div class="grid p-fluid">
                <div class="col-12 md:col-9" :key="refreshKey">
                    <div class="card">
                        
                        <p align="right">
                                <Button class="p-button-small p-button-rounded p-button-success mr-1"
                                    icon="pi pi-refresh" :loading="loading" text @click="refresh()" v-tooltip.bottom="'Reload'" />
                        </p>
                        <!-- <Divider /> -->
                        <!-- <div class="grid">
                            <div class="col-12 md:col-3">
                                <Button style="width: 10%;height: 10%;" type="button" icon="pi pi-eye" :loading="loading"
                                    @click="view_home_list(3)" v-tooltip.bottom="'View Visited List'" /><b
                                    style="color: black !important;">
                                    Homes : {{ total_stops }} </b>
                            </div>
                            <div class="col-12 md:col-3">
                                <Checkbox v-model="visit" :binary="true" />&nbsp;<Button style="width: 10%;height: 10%;"
                                    type="button" icon="pi pi-eye" :loading="loading" @click="view_home_list(1)"
                                    v-tooltip.bottom="'View Visited List'" /><b style="color: black !important;">
                                    Visited [<img src="http://maps.google.com/mapfiles/ms/icons/green-dot.png" alt=""
                                        style="height: 15px;">] :
                                    {{ visited }} </b>
                            </div>
                            <div class="col-12 md:col-3">
                                <Checkbox v-model="pending" :binary="true" />&nbsp;<Button style="width: 10%;height: 10%;"
                                    type="button" icon="pi pi-eye" :loading="loading" @click="view_home_list(2)"
                                    v-tooltip.bottom="'View Pending List'" /><b style="color: black !important;">
                                    Pending [<img src="http://maps.google.com/mapfiles/ms/icons/red-dot.png" alt=""
                                        style="height: 15px;">] : {{
                                            (total_stops - visited) }}</b>
                            </div>
                            <div class="col-12 md:col-3">
                                <Checkbox v-model="speed" :binary="true" />&nbsp;<b style="color: black !important;"> Speed
                                    [<img src="images/red_dot.png" alt="" style="height: 10px;">] : {{ (speed_marker.length)
                                    }}</b>
                            </div>
                        </div> -->
                        <!-- {{polypath}}{{ center1 }} -->
                        <img v-if="list_loader === true" src="images/loader.gif" alt="Loading"
                            style="width: 100%;height: 500px" />
                        <GoogleMap v-else-if="polyline_show && list_loader === false"
                            api-key="AIzaSyC-8ib8PMibUDDYoj5kzRzKwcusvw3Gztc" style="width: 100%; height: 500px"
                            :center="center1 == {} ? center : center1" :zoom="17">
                            <Marker :options="{ position: center, label: 'Start Point' }">
                            </Marker>
                            <Marker v-if="center1" :options="{ position: center1, label: 'End Point' }">
                            </Marker>
                            <Marker :options="{ position: marker, icon: 'images/red_dot.png' }"
                                v-for="(marker, index) in speed_marker" :key="index">
                            </Marker>
                            <MarkerCluster>
                                <Marker :options="{ position: marker, title: 'stop', label: marker.stop_name, color: 'green', icon: marker.icon }" v-for="(marker, index) in markers" :key="index" style="width:5px;height:5px">
                                </Marker>
                            </MarkerCluster>
                            <Polyline :options="polypath" />
                            <Polyline :options="live_polypath" />
                            <Marker :options="{ position: car_marker, icon: 'images/truck3.png' }"></Marker>
                        </GoogleMap>
                    </div>
                </div>
                <div class="col-12 md:col-3">
                    <div class="grid">
                        <div class="col-12 lg:col-6 xl:col-12">
                            <Fieldset legend="Ride Details" :toggleable="true" :collapsed="false"
                                style="background-color: #22C55E;">
                                <div class="flex justify-content-between mb-1">
                                    <div>
                                        <span class="block  font-medium mb-2" style="color: white !important;">Route : {{
                                            route_name
                                        }}</span>
                                        <span class="block  font-medium mb-2" style="color: white !important;">Distance : {{
                                            total_distance
                                        }}</span>
                                        <span class="block  font-medium mb-2" style="color: white !important;">Time : {{
                                            total_time }}</span>
                                        <span class="block  font-medium mb-2" style="color: white !important;"
                                            v-if="driver_name">Driver Name : {{
                                                driver_name.toUpperCase() }}</span>
                                        <span class="block  font-medium mb-2" style="color: white !important;"
                                            v-if="driver_mobile_number">Mobile
                                            Number : {{ driver_mobile_number }}</span>
                                        <span class="block  font-medium mb-2" style="color: white !important;"
                                            v-if="vehicle_registration_number">Vehicle No : {{ vehicle_registration_number
                                            }}</span>
                                        <span class="block  font-medium mb-2" style="color: white !important;"
                                            v-if="vehicle_type">Vehicle Type :
                                            {{ vehicle_type }}</span>
                                    </div>
                                </div>
                            </Fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </Sidebar>
        <Dialog header="List" v-model:visible="home_productDialog" :breakpoints="{ '960px': '75vw' }"
            :style="{ width: '70vw' }" :modal="true">
            <DataTable ref="home_dt" :value="home_list" class="p-datatable-sm" :rows="10" responsiveLayout="scroll"
                style="font-size: 12px" :paginator="true" dataKey="sr_no" :rowHover="true" showGridlines>
                <template #header>
                    <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                        <h5 class="m-0">{{ tbl_name }} Home List</h5>
                        <Button icon="pi pi-upload" v-tooltip.bottom="'Export'" @click="exportCSV" />
                    </div>
                    <div style="text-align: right; font-weight: bold">
                        <span>Total :</span>{{ home_list.length }}
                    </div>
                </template>
                <template #empty> No Record found. </template>
                <Column field="sequence_number" header="Sequence No." sortable style="min-width: 3rem">
                    <template #body="{ data }">
                        <span>{{ data.sequence_number }}</span>
                    </template>
                </Column>
                <Column field="stop_name" header="Stop Name" sortable style="min-width: 15rem">
                    <template #body="{ data }">
                        <span>{{ data.stop_name }}</span>
                    </template>
                </Column>
                <Column field="visit" header="Status" sortable>
                    <template #body="{ data }">
                        <span v-if="data.visit == 'visited' || data.visit == 'Visited'" style="color: green;">{{ data.visit
                        }}</span>
                        <span v-else style="color: red;">{{ data.visit }}</span>
                    </template>
                </Column>
                <Column field="visit_time" header="Visit Time" sortable>
                    <template #body="{ data }">
                        <span>{{ data.visit_time }}</span>
                    </template>
                </Column>
                <Column field="distance" header="Distance Mismatch(m)" sortable>
                    <template #body="{ data }">
                        <span style="color:green" v-if="data.distance < 50">{{ data.distance }} m</span>
                        <span style="color:red" v-else>{{ data.distance }} m</span>
                    </template>
                </Column>
            </DataTable>
        </Dialog>
    </div>
</template>
<script>
import EventBus from '@/AppEventBus';
import ProductService from '../service/ProductService';
import apis from "@/apis";
import axios from "axios";
import { Buffer } from 'buffer'
import { embedDashboard } from "@superset-ui/embedded-sdk";
import GoogleMapComponent from '../components/GoogleMap'
import superset_dashboard from '../components/superset_dashboard'
import gps from '../components/gps'
//import DashboardComponent from '../components/DashboardComponent'
import GoogleMapDashboard from '../components/GoogleMapDashboard'
import Map from "mapmyindia-react";
import { Tabs, Tab, TabPanels, TabPanel } from 'vue3-tabs';
import SocketioService from "../service/socketio.service.js";
import "leaflet/dist/leaflet.css";
import L from 'leaflet';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import { GoogleMap, Marker, MarkerCluster, InfoWindow, Polyline } from "vue3-google-map";
import socketioService from '../service/socketio.service.js';
import DeliveryChallan from '../components/menu/Delivery_Challan'
import IRChallan from '../components/menu/IR_Challan'
import QrcodeVue from 'qrcode.vue'
import * as XLSX from 'xlsx';
// import Superset_dashboard from './superset_dashboard.vue';
// embedDashboard({
//   id: "f151aeed-6800-42fb-befc-9a4dd719ff0b", // given by the Superset embedding UI
//   supersetDomain: "http://192.168.1.22:8088/",
//   mountPoint: document.getElementById("my-superset-container"), // any html element that can contain an iframe
//   fetchGuestToken: () => fetchGuestTokenFromBackend(),
//   dashboardUiConfig: { // dashboard UI config: hideTitle, hideTab, hideChartControls, filters.visible, filters.expanded (optional)
//       hideTitle: true,
//       filters: {
//           expanded: true,
//       }
//   },
// });
import Track_Summary from '../components/menu/Track_Summary'
import Track_Gallary from '../components/menu/Track_Gallary'
import VueGauge from '../components/VueGauge'
import solid_waste from '../components/solid_waste'
import plastic from '../components/plastic'
import fical from '../components/fical'

export default {
    data() {
        return {
            download_show:false,
            location:[],
            limit: 10,
            page_no:1,
            filters: {},
            stop_point: {},
            ride_start:{},
            ride_end:{},
            stop_point_label: "",
            district_dropdownItems: [],
            district_dropdownItem: null,
            block_dropdownItems: [],
            block_dropdownItem: null,
            village_dropdownItems: [],
            village_dropdownItem: null,
            panchayat_dropdownItems: [],
            panchayat_dropdownItem: null,
            selectedProducts: [],
            pac_id: "",
            stop_name: "",
            mob_id: "",
            delivery_status: null,
            delivery_status_options: [{ name: 'Delivered', value: 'Delivered' },
            { name: 'Pending', value: 'Pending' }
            ],
            installation_status: null,
            installation_status_options: [{ name: 'Complete', value: 'Complete' },
            { name: 'Pending', value: 'Pending' }
            ],
            ride_productDialog: false,
            original_speed_marker: [],
            speed: true,
            total_distance: "",
            total_time: "",
            loading: false,
            reg_number: '',
            vehicle_dropdownItems: [],
            vehicle_dropdownItem: '',
            refreshKey: 0,
            total_report_data: 0,
            route_name: '',
            tbl_name: '',
            original_marker_data: [],
            visit: true,
            pending: true,
            polyline_show: true,
            home_productDialog: false,
            home_list: [],
            original_home_list: [],
            list_loader: false,
            driver_name: '',
            driver_photo: '',
            driver_mobile_number: '',
            vehicle_registration_number: '',
            vehicle_model: '',
            vehicle_image: '',
            vehicle_type: '',
            fuel_type: '',
            make_year: '',
            fitness_validity: '',
            puc_validity: '',
            insurance_validity: '',
            documents: '',
            owner_name: '',
            owner_photo: '',
            owner_mobile_number: '',
            total_stops: 0,
            visited: 0,
            dl_number: '',
            dl_expiry_date: '',
            accidental_history: '',
            available24by7: '',
            shift_time_from: '',
            shift_time_to: '',
            ride_details: '',
            ride_tabs: ['Driver Details', 'Vehicle Details', 'Owner Details', 'Ride Details'],
            selected_ride_Tab: 'Driver Details',
            client_group_ids: '',
            vehicle_from_date: '',
            vehicle_to_date: '',
            set_loading: false,
            map_productDialog: false,
            stop_location_productDialog: false,
            track_ride_productDialog:false,
            selectedProduct: null,
            vehicle_data: [],
            search_vehicle_data: [],
            client_id_local: [],
            user_id: "",
            superset_id: '',
            chartData: {
                labels: ['0-3 days', '3-14 days', '>15 days'],
                datasets: [
                    {
                        label: 'Tickets',
                        data: [100, 50, 20],
                        backgroundColor: ['#3B82F6', '#3B82F6', '#3B82F6', '#3B82F6'],
                        borderColor: ['#3B82F6', '#3B82F6', '#3B82F6', '#3B82F6'],
                        borderWidth: 1
                    }
                ]
            },
            chartOptions: {
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            },
            chartData_doughnut: null,
            chartOptions_doughnut: {
                cutout: '60%',
                plugins: {
                    legend: {
                        display: false,
                        position: 'right'
                    },
                    tooltips: {
                        enabled: false
                    }
                }
            },
            //----------------------------------------------------------
            isZoomed: false,
            isZoomed1: false,
            chartData1: null,
            chartOptions1: {
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltips: {
                        enabled: false
                    }
                }
            },
            chartData3: null,
            chartOptions3: {
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltips: {
                        enabled: false
                    }
                }
            },
            //--------------------------------------------------------------
            // chartData: null,
            // chartOptions: null,
            chartData2: null,
            chartOptions2: null,
            //---------------------------------------------------------------
            Top_village: [
                { village_name: 'Palghar', Visits: 98 },
                { village_name: 'Thane', Visits: 97 },
                { village_name: 'Kalyan', Visits: 96 },
                { village_name: 'Bhiwandi', Visits: 96 },
                { village_name: 'Diva', Visits: 95 },
                { village_name: 'Vasai', Visits: 93 },
                { village_name: 'Andheri', Visits: 92 },
                { village_name: 'Dadar', Visits: 91 },
                { village_name: 'karjat', Visits: 90 },
                { village_name: 'kasara', Visits: 89 },
            ],
            Top_cluster: [
                { cluster_name: 'Cluster Name 1', Visits: 99 },
                { cluster_name: 'Cluster Name 2', Visits: 97 },
                { cluster_name: 'Cluster Name 3', Visits: 95 },
                { cluster_name: 'Cluster Name 4', Visits: 94 },
                { cluster_name: 'Cluster Name 5', Visits: 94 },
                { cluster_name: 'Cluster Name 6', Visits: 93 },
                { cluster_name: 'Cluster Name 7', Visits: 92 },
                { cluster_name: 'Cluster Name 8', Visits: 91 },
                { cluster_name: 'Cluster Name 9', Visits: 90 },
                { cluster_name: 'Cluster Name 10', Visits: 89 },
            ],
            Top_districts: [
                { districts_name: 'Amravati', Visits: 97 },
                { districts_name: 'Sangli', Visits: 96 },
                { districts_name: 'Satara', Visits: 96 },
                { districts_name: 'Solapur', Visits: 95 },
                { districts_name: 'Kolhapur', Visits: 95 },
                { districts_name: 'Pune', Visits: 94 },
                { districts_name: 'Akola', Visits: 93 },
                { districts_name: 'Buldhana', Visits: 92 },
                { districts_name: 'Yavatmal', Visits: 92 },
                { districts_name: 'Washim', Visits: 91 },
            ],
            Bottom_village: [
                { village_name: 'Panvel', Visits: 20 },
                { village_name: 'Swawood', Visits: 30 },
                { village_name: 'khandeshwar', Visits: 40 },
                { village_name: 'Mansarovar', Visits: 45 },
                { village_name: 'Nerul', Visits: 45 },
                { village_name: 'Sanpada', Visits: 47 },
                { village_name: 'Vashi', Visits: 48 },
                { village_name: 'Mankhurd', Visits: 49 },
                { village_name: 'Turbhe', Visits: 49 },
                { village_name: 'Ghansoli', Visits: 51 },
            ],
            Bottom_cluster: [
                { cluster_name: 'Cluster Name 1', Visits: 20 },
                { cluster_name: 'Cluster Name 2', Visits: 35 },
                { cluster_name: 'Cluster Name 3', Visits: 40 },
                { cluster_name: 'Cluster Name 4', Visits: 41 },
                { cluster_name: 'Cluster Name 5', Visits: 42 },
                { cluster_name: 'Cluster Name 6', Visits: 43 },
                { cluster_name: 'Cluster Name 7', Visits: 43 },
                { cluster_name: 'Cluster Name 8', Visits: 44 },
                { cluster_name: 'Cluster Name 9', Visits: 45 },
                { cluster_name: 'Cluster Name 10', Visits: 48 },
            ],
            Bottom_districts: [
                { districts_name: 'Beed', Visits: 20 },
                { districts_name: 'Jalna', Visits: 25 },
                { districts_name: 'Dharashiv', Visits: 28 },
                { districts_name: 'Nanded', Visits: 29 },
                { districts_name: 'Latur', Visits: 32 },
                { districts_name: 'Parbhani', Visits: 33 },
                { districts_name: 'Hingoli', Visits: 35 },
                { districts_name: 'Bhandara', Visits: 36 },
                { districts_name: 'Chandrapur', Visits: 36 },
                { districts_name: 'Gadchiroli ', Visits: 38 },
            ],
            fullPage: true,
            user_key: "",
            client_id_dropdown: [],
            block_dropdown: [
                { name: 'Block1', value: 'Block1' },
                { name: 'Block2', value: 'Block2' },
                { name: 'Block3', value: 'Block3' },
                { name: 'Block4', value: 'Block4' },
                { name: 'Block5', value: 'Block5' },
            ],
            village_dropdown: [
                { name: 'Panvel', value: 'Panvel' },
                { name: 'Swawood', value: 'Swawood' },
                { name: 'khandeshwar', value: 'khandeshwar' },
                { name: 'Mansarovar', value: 'Mansarovar' },
                { name: 'Nerul', value: 'Nerul' },
                { name: 'Sanpada', value: 'Sanpada' },
                { name: 'Vashi', value: 'Vashi' },
                { name: 'Mankhurd', value: 'Mankhurd' },
                { name: 'Turbhe', value: 'Turbhe' },
                { name: 'Ghansoli', value: 'Ghansoli' },
                { name: 'Palghar', value: 'Palghar' },
                { name: 'Diva', value: 'Diva' },
                { name: 'Vasai', value: 'Vasai' },
                { name: 'karjat', value: 'karjat' },
                { name: 'kasara', value: 'kasara' },
            ],
            taluka_dropdown: [
                { name: 'Ahmednagar', value: 'Ahmednagar' },
                { name: 'Akole', value: 'Akole' },
                { name: 'Jamkhed', value: 'Jamkhed' },
                { name: 'Karjat', value: 'Karjat' },
                { name: 'Kopargaon', value: 'Kopargaon' },
                { name: 'Nagar', value: 'Nagar' },
                { name: 'Nevasa', value: 'Nevasa' },
                { name: 'Parner', value: 'Parner' },
                { name: 'Pathardi', value: 'Pathardi' },
                { name: 'Rahata', value: 'Rahata' },
                { name: 'Sangamner', value: 'Sangamner' },
                { name: 'Shevgaon', value: 'Shevgaon' },
                { name: 'Shrigonda', value: 'Shrigonda' },
                { name: 'Shrirampur', value: 'Shrirampur' },
                { name: 'Akola', value: 'Akola' },
                { name: 'Akot', value: 'Akot' },
                { name: 'Balapur', value: 'Balapur' },
                { name: 'Murtijapur', value: 'Murtijapur' },
                { name: 'Patur', value: 'Patur' },
                { name: 'Telhara', value: 'Telhara' },
                { name: 'Achalpur', value: 'Achalpur' },
                { name: 'Amravati', value: 'Amravati' },
                { name: 'Anjangaon Surji', value: 'Anjangaon Surji' },
                { name: 'Bhatkuli', value: 'Bhatkuli' },
                { name: 'Chandur Railway', value: 'Chandur Railway' },
                { name: 'Chikhaldara', value: 'Chikhaldara' },
                { name: 'Daryapur', value: 'Daryapur' },
                { name: 'Dharni', value: 'Dharni' },
                { name: 'Morshi', value: 'Morshi' },
                { name: 'Nandgaon-Khandeshwar', value: 'Nandgaon-Khandeshwar' },
                { name: 'Teosa', value: 'Teosa' },
                { name: 'Aurangabad', value: 'Aurangabad' },
                { name: 'Gangapur', value: 'Gangapur' },
                { name: 'Kannad', value: 'Kannad' },
                { name: 'Khuldabad', value: 'Khuldabad' },
                { name: 'Paithan', value: 'Paithan' },
                { name: 'Phulambri', value: 'Phulambri' },
                { name: 'Sillod', value: 'Sillod' },
                { name: 'Soegaon', value: 'Soegaon' },
                { name: 'Vaijapur', value: 'Vaijapur' },
                { name: 'Beed', value: 'Beed' },
                { name: 'Dharur', value: 'Dharur' },
                { name: 'Georai', value: 'Georai' },
                { name: 'Kaij', value: 'Kaij' },
                { name: 'Majalgaon', value: 'Majalgaon' },
                { name: 'Parli', value: 'Parli' },
                { name: 'Patoda', value: 'Patoda' }
            ],
            district_dropdown: [
                { name: 'Ahmednagar', value: 'Ahmednagar' },
                { name: 'Akola', value: 'Akola' },
                { name: 'Amravati', value: 'Amravati' },
                { name: 'Aurangabad', value: 'Aurangabad' },
                { name: 'Beed', value: 'Beed' },
                { name: 'Bhandara', value: 'Bhandara' },
                { name: 'Buldhana', value: 'Buldhana' },
                { name: 'Chandrapur', value: 'Chandrapur' },
                { name: 'Dhule', value: 'Dhule' },
                { name: 'Gadchiroli', value: 'Gadchiroli' },
                { name: 'Gondia', value: 'Gondia' },
                { name: 'Hingoli', value: 'Hingoli' },
                { name: 'Jalgaon', value: 'Jalgaon' },
                { name: 'Jalna', value: 'Jalna' },
                { name: 'Kolhapur', value: 'Kolhapur' },
                { name: 'Latur', value: 'Latur' },
                { name: 'Mumbai City', value: 'Mumbai' },
                { name: 'Mumbai Suburban', value: 'Mumbai' },
                { name: 'Nagpur', value: 'Nagpur' },
                { name: 'Nanded', value: 'Nanded' },
                { name: 'Nandurbar', value: 'Nandurbar' },
                { name: 'Nashik', value: 'Nashik' },
                { name: 'Osmanabad', value: 'Osmanabad' },
                { name: 'Palghar', value: 'Palghar' },
                { name: 'Parbhani', value: 'Parbhani' },
                { name: 'Pune', value: 'Pune' },
                { name: 'Raigad', value: 'Raigad' },
                { name: 'Ratnagiri', value: 'Ratnagiri' },
                { name: 'Sangli', value: 'Sangli' },
                { name: 'Satara', value: 'Satara' },
                { name: 'Sindhudurg', value: 'Sindhudurg' },
                { name: 'Solapur', value: 'Solapur' },
                { name: 'Thane', value: 'Thane' },
                { name: 'Wardha', value: 'Wardha' },
                { name: 'Washim', value: 'Washim' },
                { name: 'Yavatmal', value: 'Yavatmal' }
            ],
            client_id_search: '',
            district_id_search: '',
            taluka_id_search: '',
            village_id_search: '',
            block_id_search: '',
            routeitem: '',
            routeitems: [],
            isLoadingModel: false,
            pieOptions: null,
            routeitem_multiselect: '',
            tabs: ['Live Ride Tracking Dashboard', 'Track Report','SUMMARY','Gallery'],
            selectedTab: "Live Ride Tracking Dashboard",
            pieData: {},
            pieData1: {},
            center: { lat: 19.0626704, lng: 73.005094 },
            center1: {},
            car_marker: {},
            print_DC_Model: false,
            print_IR_Model:false,
            upload_Model:false,
            print_delivery_chalan_data: [],
            vehicle_map_start: {},
            vehicle_map_end: {},
            map_polypath: {},
            centerstart: {},
            polyline: [
            ],
            live_polypath: [],
            polyline1: [
            ],
            polypath: {
                // path: this.polyline,
                // geodesic: true,
                // strokeColor: '#FF0000',
                // strokeOpacity: 1.0,
                // strokeWeight: 2,
            },
            ride_polypath:{},
            search_key: "",
            home: true,
            random: 0,
            token: '',
            get_date: "",
            get_date_2: "",
            locations1: [],
            locations: [
                { lat: 19.0626704, lng: 73.005094, name: "Prathamesh" },
                { lat: 28.38, lng: 77.12, name: "Sanjay" }
            ],
            markers: []
            ,
            ride_markers:[],
            speed_marker: [],
            messages: [],
            inputMessageText: "",
            form: {
                roomName: "63a939f2b319a2f01eb75798",
                userName: "639c6caae0aa678e9f6de543",
            },
            products: null,
            todayslectures: [],
            dashcount: {
                "riders": 0,
                "drivers": 0,
                "driverowner": 0,
                "vehicles": 0,
                "owners": 0,
                "admin": 0,
                "travels": 0,
                "schools": 0,
                "alerts": 0,
                "today_alerts": 0,
                "today_travels": 0,
                "school_buses": 0,
                "pending_alerts": 0,
                "routes": 0,
                "stops": 0
            },
            // center: [37,7749, -122,4194],
            lineData: {
                labels: ['0', '0 to 20', '20 to 40', '40 to 60', '60 to 80', '80 to 100'],
                datasets: [
                    {
                        label: 'Network',
                        data: [],
                        backgroundColor: '#00bb7e',
                    },
                    // {
                    // 	label: 'Sales',
                    // 	data: [],
                    // 	fill: false,
                    // 	backgroundColor: '#00bb7e',
                    // 	borderColor: '#00bb7e',
                    // 	tension: 0.4
                    // }
                ]
            },
            travellist: [],
            travellist_filter: [],
            report_data: [],
            track_loading:false,
            lastNumber: 1,
            barData: {
                labels: [],
                height: "150px",
                datasets: [
                    {
                        label: 'Total Rides',
                        backgroundColor: '#2f4860',
                        data: []
                    }
                ]
            },
            barData1: {
                labels: [],
                datasets: [
                    {
                        label: 'No Of Lectures by Teacher',
                        backgroundColor: '#2f4860',
                        data: []
                    }
                ]
            },
            barOptions: null,
            barOptions1: null,
            items: [
                { label: 'Add New', icon: 'pi pi-fw pi-plus' },
                { label: 'Remove', icon: 'pi pi-fw pi-minus' }
            ],
            lineOptions: null,
        }
    },
    productService: null,
    themeChangeListener: null,
    async mounted() {
        // this.load_map();
        // this.productService.getProductsSmall().then(data => this.products = data);
        this.themeChangeListener = (event) => {
            if (event.dark)
                this.applyDarkTheme();
            else
                this.applyLightTheme();
        };
        EventBus.on('change-theme', this.themeChangeListener);
        if (this.isDarkTheme()) {
            this.applyDarkTheme();
        }
        else {
            this.applyLightTheme();
        }
        // this.get_date=new Date();
        // this.datausagereport();
        // this.get_date_2=new Date();
        //  await this.setupLeafletMap();
        await this.gettodaysTravelList();
        // this.networkconnectivityreport();
        // this.todayslecturereport();
        // this.teacherlecturereportadmin();
        //   this.timer = setInterval(() => {
        // 	 this.getrandomLatlong( this.getRandNumber())
        // }, 1000)
        // this.pieOptions = {
        // 		plugins: {
        // 			legend: {
        // 				labels: {
        // 					color: '#495057'
        // 				}
        // 			}
        // 		}
        // 	};
        // alert(this.dashcount.drivers)
        //this.chartData = this.setChartData();
        //this.chartOptions = this.setChartOptions();
        this.chartData2 = this.setChartData2();
        this.chartOptions2 = this.setChartOptions2();
        this.chartData1 = this.setChartData1();
        this.chartData3 = this.setChartData3();
        this.chartData_doughnut = this.setChartData_doughnut();
    },
    beforeUnmount() {
        EventBus.off('change-theme', this.themeChangeListener);
    },
    async created() {
        window.Buffer = window.Buffer || Buffer
        // alert(this.token)
        //         supersetEmbeddedSdk.embedDashboard({
        //   id: "f151aeed-6800-42fb-befc-9a4dd719ff0b", // given by the Superset embedding UI
        // supersetDomain: "http://192.168.1.22:8088/",
        // mountPoint: document.getElementById("my-superset-container"), // any html element that can contain an iframe
        // fetchGuestToken: () =>  this.token,
        // dashboardUiConfig: { // dashboard UI config: hideTitle, hideTab, hideChartControls, filters.visible, filters.expanded (optional)
        //      hideTitle: true,
        //     // filters: {
        //     //     expanded: true,
        //     // }
        //   }});
        // this.load_map();
        this.productService = new ProductService();
        this.user_key = localStorage.getItem("user_key");
        // alert(localStorage.getItem("client_id"));
        if (localStorage.getItem("client_id")) {
            this.client_id_local.push(localStorage.getItem("client_id"));
        }
        if (localStorage.getItem('client_group_ids')) {
            this.client_id_local = JSON.parse(localStorage.getItem('client_group_ids'));
            this.client_group_ids = JSON.parse(localStorage.getItem('client_group_ids'));
        }
        this.user_id = localStorage.getItem('id')
        //await this.dashboardcount();
        //await this.dashboardRideData();
        await this.route_list();
        await this.get_client_list();
        //await this.get_pending_alert_count();
        // await this.superset_api();
        // this.load_map_superset();
        // var token=await this.superset_api();
        // alert(this.token);
        // this.load_map();
        //first load default SBM Dashboard
        this.superset_id = '10ab0a3c-8466-4e86-adc6-770396cdff9e';
        this.selectedTab = 'Live Ride Tracking Dashboard';
    },
    watch: {
        speed: function (val) {
            var marker_data = [];
            var data = this.original_speed_marker;
            for (let z = 0; z < data.length; z++) {
                if (this.speed == true) {
                    marker_data.push(data[z]);
                }
            }
            this.speed_marker = marker_data;
        },
        visit: function (val) {
            var stop_data = [];
            var data = this.original_marker_data;
            for (let z = 0; z < data.length; z++) {
                if (this.visit == true && data[z].status == 'visited') {
                    stop_data.push(data[z]);
                }
                if (this.pending == true && data[z].status == 'pending') {
                    stop_data.push(data[z]);
                }
            }
            this.markers = stop_data;
        },
        pending: function (val) {
            var stop_data = [];
            var data = this.original_marker_data;
            for (let z = 0; z < data.length; z++) {
                if (this.visit == true && data[z].status == 'visited') {
                    stop_data.push(data[z]);
                }
                if (this.pending == true && data[z].status == 'pending') {
                    stop_data.push(data[z]);
                }
            }
            this.markers = stop_data;
        },
        // live_polypath:function(val)
        // {
        //     this.hide(1);
        //     setTimeout(function () { this.hide(2) }.bind(this), 50)
        // },
        selectedTab() {
            if (this.selectedTab == "Track Report") {
                this.selectedProducts = [];
                this.getDistrictData();
                this.track_report_list();
                this.track_report_count();
                //call api for report list 
            }
            // if (this.selectedTab == "SBM Dashboard") 
            // {
            //     this.superset_id = '10ab0a3c-8466-4e86-adc6-770396cdff9e';
            // }
            // if (this.selectedTab == "Individual/Place Visits") 
            // {
            //     this.superset_id = '3d7f5fbe-e352-47fd-b6a4-3ac04cf897a7';
            // }
            // if (this.selectedTab == "Vehicles Visits") 
            // {   
            //     this.vehicle_data=[];
            //     this.search_vehicle_data=[];
            //     this.get_vehicle_type_master();
            //     this.get_dashboard_vehicle_list(1);
            // }
            // if (this.selectedTab == "Vehicles Summary") 
            // {
            //     this.superset_id = '687f9c1b-f5d6-444c-b353-3413cfcc140d';
            // }
            // if (this.selectedTab == "Dumping Ground") 
            // {
            //     this.superset_id='77cb787e-1a98-471a-a6be-ba69296ae97f';
            // }
            // if (this.selectedTab =='Top/Bottom Performers') 
            // {
            //     this.superset_id = 'fbe0589f-20e9-4c66-b251-3dc4dc9963f7';
            // }
            // if (this.selectedTab =='30 Days Analysis') 
            // {
            //     this.superset_id = '1a0a1012-9e3d-4305-87b5-5ba657b9ba12';
            // }
        },
        polyline() {
            alert('ok');
            this.home = true;
            this.home = false;
        }
    },
    methods: {
        onUpload(event) 
        {
            const fileUp = event.files[0];
            console.log(fileUp);
        },
        update_receipt_details(filename,url,data)
        {
            if (filename && data.ride_id && data.stop_id) 
            {
                var details={
                    ride_id :data.ride_id ,
                    stop_id :data.stop_id,
                    photo   :filename
                }
                var promise2 = apis.update_receipt_photo(details);
                    promise2
                    .then(response => 
                    {   this.isLoadingModel = false;
                        this.$swal(response.data.message);
                        this.track_report_list();
                    });
            }
            else
            {
                                this.isLoadingModel = false;
                                this.$toast.add({
                                    severity: "error",
                                    summary: "error",
                                    detail: "error!!!",
                                    life: 3000,
                                });
                                return false;
            }
        },
        handleFileUpload(event,data) 
        {  
            const fileUp = event.files[0];
            var file     = fileUp;
            if (file.name && file.type) 
            {      
                var filename=data['user_id']+"-"+data['uicode']+"-"+data['time']+"_scan_image.jpg";
                var file_data={
                    //filePath:file.name,
                    filePath:filename,
                    contentType: file.type
                }
                //upload image
                this.isLoadingModel = true;
                var promise2 = apis.upload_receipt(file_data);
                        promise2
                        .then(response => 
                        {
                            if (response.data.status==true) 
                            {   
                                this.update_receipt_details(filename,response.data.data,data);
                            }
                            else
                            {   
                                this.isLoadingModel = false;
                                this.$toast.add({
                                    severity: "error",
                                    summary: "error",
                                    detail: "Please Upload Receipt",
                                    life: 3000,
                                });
                                return false;
                            }
                            
                        });
            }
            else
            {   this.isLoadingModel = false;
                this.$toast.add({
                    severity: "error",
                    summary: "error!!!",
                    detail: "Please Upload Receipt",
                    life: 3000,
                });
                return false;
            }
        },
        download_receipt(receipt)
        {   
            var receipt_url = 'https://travelsafe-docs.s3.ap-south-1.amazonaws.com/'+receipt;
            window.open(receipt_url,"_blank");
        },
        async onPage(event) 
        {
            this.lazyParams = event;
            this.page_no = event.page + 1;
            this.limit = event.rows;
      
            if (this.total_report_data > 0) 
            {
                this.track_report_list();
            }
        },
        async getRideData_track(id)
        {   
            this.list_loader=true;
            var data = { ride_id: id, speed: true };
            var promise = apis.getRideDataLive(data);
            promise
                .then(response => {
                    var list = response.data.data;
                    if (list==[]) 
                    {
                        var promise2 = apis.get_RideDataHistory(data);
                        promise2
                        .then(response => {
                        this.list_loader=false;
                        this.total_distance = response.data.distance;
                        this.total_time = response.data.ride_time;
                        list = response.data.data; 
                        var length = list.length;
                        this.ride_start = { lat: parseFloat(list[0].lat), lng: parseFloat(list[0].lng) };
                        this.ride_end   = { lat: parseFloat(list[length - 1].lat), lng: parseFloat(list[length - 1].lng) };
                        var data = [];
                        for (let x = 0; x < list.length; x++) 
                        {
                                if (list[x].lat && list[x].lng) 
                                {
                                    data.push({ lat: parseFloat(list[x].lat), lng: parseFloat(list[x].lng) });
                                }
                        }
                        this.ride_polypath = {
                                path: data,
                                geodesic: true,
                                strokeColor: 'blue',
                                strokeOpacity: 0.5,
                                strokeWeight: 5,
                            }
                        });

                    }
                    else
                    {   this.list_loader=false;
                        this.total_distance = response.data.distance;
                        this.total_time = response.data.ride_time;
                        var length = list.length;
                        this.ride_start = { lat: parseFloat(list[0].lat), lng: parseFloat(list[0].lng) };
                        this.ride_end   = { lat: parseFloat(list[length - 1].lat), lng: parseFloat(list[length - 1].lng) };
                        var data = [];
                        for (let x = 0; x < list.length; x++) 
                        {
                                if (list[x].lat && list[x].lng) 
                                {
                                    data.push({ lat: parseFloat(list[x].lat), lng: parseFloat(list[x].lng) });
                                }
                        }
                        this.ride_polypath = {
                                path: data,
                                geodesic: true,
                                strokeColor: 'blue',
                                strokeOpacity: 0.5,
                                strokeWeight: 5,
                            }
                    }
                    

                })
        },
        async getRideGroupStopData_track(id)
        {   var stops_data = [];
            var data = { _id: id };
            var promise = apis.getRideGroupStopData(data);
            promise
                .then(response => {
                    var list = response.data.data;
                    for (let x = 0; x < list.length; x++) 
                    {   var icon = '';
                        if (list[x].status == 'visited') 
                        {   
                            icon = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png';
                            stops_data.push({
                                lat: parseFloat(list[x].stop_location.lat),
                                lng: parseFloat(list[x].stop_location.lng),
                                'stop_name': list[x].stop_name,
                                icon: icon,
                                status: list[x].status
                            });
                        }
                    }
                    this.ride_markers = stops_data;
                });
        },
        async view_ride(data) {
            var ride_id = data.ride_id;
            await this.getRideMaster(ride_id);
            await this.getRideData_track(ride_id);
           
            //old
            //await this.getRideGroupStopData_track(ride_id);
            
            //new
            var stops_data = [];
            var icon = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png';
                            stops_data.push({
                                lat: parseFloat(data.lat),
                                lng: parseFloat(data.lng),
                                'stop_name': data.stop_name,
                                icon: icon,
                                status: 'Visited'
                            });
            this.ride_markers = stops_data;


            this.track_ride_productDialog=true;
           
        },
        track_map(data) {
            this.stop_point = {};
            this.stop_point_label = "";
            if (data.group_stops && data.group_stops.location) {
                this.stop_point = { lat: parseFloat(data.group_stops.location.lat), lng: parseFloat(data.group_stops.location.lng) };
            }
            this.stop_point_label = data.stop_name;
            this.stop_location_productDialog = true;
        },
        getPanchayatData(num) {
            this.panchayat_dropdownItem = null;
            this.panchayat_dropdownItems = [];
            var district_code = [];
            var block_code = [];
            this.set_loading = true;
            if (num == 2) {
                if (this.district_dropdownItem) {
                    for (var j = 0; j < this.district_dropdownItem.length; j++) {
                        district_code.push(this.district_dropdownItem[j].value);
                    }
                }
                if (this.block_dropdownItem) {
                    for (var i = 0; i < this.block_dropdownItem.length; i++) {
                        block_code.push(this.block_dropdownItem[i].value);
                    }
                }
            }
            else if (num == 1) {
                if (this.district_dropdownItem) {
                    district_code.push(this.district_dropdownItem.value);
                }
                if (this.block_dropdownItem) {
                    block_code.push(this.block_dropdownItem.value);
                }
            }
            var data = {
                district_code: district_code,
                block_code: block_code,
                count: false,
            }
            var promise = apis.getPanchayatData(data);
            var temp_data = [];
            promise.then((response) => {
                this.set_loading = false;
                if (response.data.data) {
                    for (var k = 0; k < response.data.data.length; k++) {
                        temp_data.push({
                            name: response.data.data[k]["Local Body Name"],
                            value: response.data.data[k]["Local Body Code"],
                        })
                    }
                    this.panchayat_dropdownItem = null;
                    this.panchayat_dropdownItems = temp_data;
                }
            });
        },
        async get_village(search) {
            var district_code = [];
            var block_code = [];
            var panchayat_code = [];
            if (this.district_dropdownItem) {
                for (var d = 0; d < this.district_dropdownItem.length; d++) {
                    district_code.push(this.district_dropdownItem[d].value);
                }
            }
            if (this.block_dropdownItem) {
                for (var c = 0; c < this.block_dropdownItem.length; c++) {
                    block_code.push(this.block_dropdownItem[c].value);
                }
            }
            if (this.panchayat_dropdownItem) {
                for (var e = 0; e < this.panchayat_dropdownItem.length; e++) {
                    panchayat_code.push(this.panchayat_dropdownItem[e].value);
                }
            }
            var data = {
                "count": false,
                "page_no": 1,
                "limit": 10000000,
                district_code: district_code,
                block_code: block_code,
                panchayat_code: panchayat_code
            };
            if (search != 1) {
                data.search_name = search.value;
            }
            var promise = apis.getVillageData(data);
            promise.then((response) => {
                this.village_dropdownItems = [];
                var temp = response.data.data;
                for (let a = 0; a < temp.length; a++) {
                    this.village_dropdownItems.push({ name: temp[a].village_name, value: temp[a].village_code });
                }
            });
        },
        getBlockData(num) {
            this.block_dropdownItem = null;
            this.block_dropdownItems = [];
            var district_code = [];
            this.set_loading = true;
            if (num == 2) {
                if (this.district_dropdownItem) {
                    for (var i = 0; i < this.district_dropdownItem.length; i++) {
                        district_code.push(this.district_dropdownItem[i].value)
                    }
                }
            }
            else if (num == 1) {
                if (this.district_dropdownItem) {
                    district_code.push(this.district_dropdownItem.value);
                }
            }
            var data =
            {
                district_code: district_code,
                count: false,
            };
            var promise = apis.getBlockData(data);
            promise.then((response) => {
                this.set_loading = false;
                if (response.data.data) {
                    var temp_data = [];
                    for (var j = 0; j < response.data.data.length; j++) {
                        temp_data.push({
                            name: response.data.data[j].name,
                            value: response.data.data[j].code,
                        });
                    }
                    this.block_dropdownItem = null;
                    this.block_dropdownItems = temp_data;
                }
            });
        },
        async getDistrictData() {
            this.district_dropdownItem = null;
            const client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')) : [];
            var client_id = this.client_id_search.code
                ? this.client_id_search.code
                : localStorage.getItem("client_id");
            this.loading = true;
            var data = {
                client_id: client_id,
                "client_group_ids": client_group_ids,
                count: false,
            };
            var promise = apis.getStateData(data);
            promise.then((response) => {
                this.loading = false;
                if (response.data.data) {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({
                            name: response.data.data[x].name,
                            value: response.data.data[x].code,
                        });
                    }
                    
                    this.district_dropdownItems = temp_data;
                    this.district_dropdownItem = null;
                    if (
                                    this.district_dropdownItems.length > 0 &&
                                    localStorage.getItem("district_id")
                              ) {
                                    var data = this.district_dropdownItems;
                                    var temp_district_id = this.string_to_array_converter(
                                          localStorage.getItem("district_id")
                                    );
                                    const valuesFromArr1 = new Set(temp_district_id);
                                    const filteredArr2 = data.filter((obj) =>
                                          valuesFromArr1.has(obj.value)
                                    );
                                    this.district_dropdownItems = filteredArr2;
                              }
                }
            });
        },
        string_to_array_converter(str) {
                  if (str) {
                        var substrings = str.split(",");
                        var strArray = substrings.map(function (substring) {
                              return parseFloat(substring.trim());
                        });
                        return strArray;
                  } else {
                        return [];
                  }
            },
        track_report_count: function () {
            this.total_report_data = 0;
            var client_id = this.client_id_search.code ? this.client_id_search.code : localStorage.getItem("client_id");
            var client_group_ids = [];
            if (localStorage.getItem('client_group_ids')) {
                client_group_ids = JSON.parse(localStorage.getItem('client_group_ids'));
            }
            else {
                client_group_ids.push(localStorage.getItem('client_id'));
            }
            var block_code = [];
            var district_code = [];
            var village_code = [];
            var panchayat_code = [];
            if (this.block_dropdownItem) {
                for (var c = 0; c < this.block_dropdownItem.length; c++) {
                    block_code.push(this.block_dropdownItem[c].value);
                }
            }
            if (this.district_dropdownItem) {
                for (var d = 0; d < this.district_dropdownItem.length; d++) {
                    district_code.push(this.district_dropdownItem[d].value);
                }
            }
            else
            {   
                if (localStorage.getItem("district_id")) 
                {   
                    var U=this.string_to_array_converter(localStorage.getItem("district_id"));
                    district_code=U;
                }
            }
            if (this.panchayat_dropdownItem) {
                for (var f = 0; f < this.panchayat_dropdownItem.length; f++) {
                    panchayat_code.push(this.panchayat_dropdownItem[f].value);
                }
            }
            if (this.village_dropdownItem) {
                for (var e = 0; e < this.village_dropdownItem.length; e++) {
                    village_code.push(this.village_dropdownItem[e].value);
                }
            }
            var data = {
                count: true,
                district_code: district_code,
                block_code: block_code,
                village_code: village_code,
                panchayat_code: panchayat_code,
                "client_group_ids": client_group_ids,
                client_id: client_id,
                PACS_id: this.pac_id,
                stop_name: this.stop_name,
                mobile_no: this.mob_id,
                delivery_status: this.delivery_status ? this.delivery_status.value : "",
                installation_status: this.installation_status ? this.installation_status.value : "",
            };
            // this.loading = true;
            var promise = apis.track_report_master(data);
            promise.then((response) => {
                // this.loading = false;
                this.total_report_data = response.data.data;
            });
        },
        reset_track_report() {
            this.pac_id = "";
            this.stop_name = "";
            this.mob_id = "";
            this.delivery_status = null;
            this.installation_status = null;
            this.district_dropdownItem = null;
            this.block_dropdownItem = null;
            this.panchayat_dropdownItem = null;
            this.village_dropdownItem = null;
            this.village_dropdownItem = null;
            this.track_report_list();
            this.track_report_count();
        },
        search_track_report_list() {
            this.track_report_list();
            this.track_report_count();
        },
        track_report_list: function (type) {
            this.selectedProducts = [];
            var client_id = this.client_id_search.code ? this.client_id_search.code : localStorage.getItem("client_id");
            var client_group_ids = [];
            if (localStorage.getItem('client_group_ids')) {
                client_group_ids = JSON.parse(localStorage.getItem('client_group_ids'));
            }
            else {
                client_group_ids.push(localStorage.getItem('client_id'));
            }
            
            var block_code = [];
            var district_code = [];
            var village_code = [];
            var panchayat_code = [];
            if (this.block_dropdownItem) {
                for (var c = 0; c < this.block_dropdownItem.length; c++) {
                    block_code.push(this.block_dropdownItem[c].value);
                }
            }
            if (this.district_dropdownItem) {
                for (var d = 0; d < this.district_dropdownItem.length; d++) {
                    district_code.push(this.district_dropdownItem[d].value);
                }
            }
            else
            {   
                if (localStorage.getItem("district_id")) 
                {   
                    var U=this.string_to_array_converter(localStorage.getItem("district_id"));
                    district_code=U;
                }
            }
            if (this.panchayat_dropdownItem) {
                for (var f = 0; f < this.panchayat_dropdownItem.length; f++) {
                    panchayat_code.push(this.panchayat_dropdownItem[f].value);
                }
            }
            if (this.village_dropdownItem) {
                for (var e = 0; e < this.village_dropdownItem.length; e++) {
                    village_code.push(this.village_dropdownItem[e].value);
                }
            }
            var data = {
                limit: this.limit,
                page_no: this.page_no,
                count: false,
                district_code: district_code,
                block_code: block_code,
                village_code: village_code,
                panchayat_code: panchayat_code,
                "client_group_ids": client_group_ids,
                client_id: client_id,
                PACS_id: this.pac_id,
                stop_name: this.stop_name,
                mobile_no: this.mob_id,
                delivery_status: this.delivery_status ? this.delivery_status.value : "",
                installation_status: this.installation_status ? this.installation_status.value : "",
            };
            this.track_loading = true;
            var promise = apis.track_report_master(data, this.id);
            promise.then((response) => {
                this.track_loading = false;
                this.report_data = response.data.data;
                if (type==1) 
                {  
                    this.download_excel();
                }
            });
            // console.log(data);
        },
        async download_excel()
        {
             // Convert JSON to worksheet
             var Excel_json=[];
             this.report_data.forEach(item => {
                item['visited_date'] = this.dateFormatDMY(item['visited_date']);
            });
            
             for (let index = 0; index < this.report_data.length; index++) 
             {
                Excel_json.push(
                        {   
                        "PACS ID"           :this.report_data[index]['PACS_id'],
                        "Stop"              :this.report_data[index]['stop_name'],
                        "Delivery Status"   :this.report_data[index]['delivery_status'],
                        "Installation Status":this.report_data[index]['installation_status'],
                        "District"          :this.report_data[index]['district_name'],
                        "Block"             :this.report_data[index]['block_name'],
                        "Contact Person"    :this.report_data[index]['contact_person_name'],
                        "Mobile"            :this.report_data[index]['mobile_no'],
                        "Challan No"        :this.report_data[index]['sr_no'],
                        "Delivery Date"     :this.report_data[index]['visited_date'],
                        }
                        )
                
             }
            const ws = XLSX.utils.json_to_sheet(Excel_json);

            // Create a workbook
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

            // Save as Excel file
            XLSX.writeFile(wb, 'Track_Report.xlsx');


            //await this.$refs.track_dt.exportCSV();
        },
        async format_dateDMY(originalDate)
        {
            const parts = originalDate.split('-');
            const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
            return formattedDate;
        },
        async Print_DC_selected() {
            if (this.selectedProducts.length == 0) {
                alert('Please select  atleast one record')
                return false;
            }
            this.print_delivery_chalan_data = [];
            for (let index = 0; index < this.selectedProducts.length; index++) {
                this.print_delivery_chalan_data.push({ data: this.selectedProducts[index] });
            }
            this.print_DC_Model = true;
        },
        async Print_IR_selected() {
            if (this.selectedProducts.length == 0) {
                alert('Please select  atleast one record')
                return false;
            }
            this.print_delivery_chalan_data = [];
            for (let index = 0; index < this.selectedProducts.length; index++) {
                this.print_delivery_chalan_data.push({ data: this.selectedProducts[index] });
            }
            this.print_IR_Model = true;
        },
        async OnSubmit()
        {   
            this.print_DC_Model = false;
            this.print_IR_Model = false;
        },
        async Gallery_OnSubmit()
        {
            console.log("abc");
        },
        async summary_OnSubmit(data)
        {
            this.selectedTab=data;
            
        },
        async Print_DC(data) {
            this.print_delivery_chalan_data = [];
            this.print_delivery_chalan_data.push({ data: data });
            //this.print_delivery_chalan_data.push({data:data});
            this.print_DC_Model = true;
        },
        async ride_list() {
            this.ride_productDialog = true;
        },
        async view_home_list(flag) {
            var data = this.original_home_list;
            this.home_list = [];
            if (flag == 1) {
                this.home_list = data.filter(item => item.visit === "visited");
                this.tbl_name = 'Visited';
            }
            else if (flag == 2) {
                this.home_list = data.filter(item => item.visit === "pending");
                this.tbl_name = 'Pending';
            }
            else {
                this.home_list = data;
            }
            this.home_productDialog = true;
        },
        async exportCSV3() {
            this.limit = this.total_report_data;
            this.track_report_count();
            this.track_report_list(1);
            
            },
        async exportCSV() {
            await this.$refs.home_dt.exportCSV();
        },
        async exportCSV2() {
            await this.$refs.ride_dt.exportCSV();
        },
        dateFormatDMY(inputDate) {
            var postdate = inputDate;
            if (inputDate) {
                inputDate = new Date(inputDate);
                if (inputDate.toString() == 'NaN-NaN-NaN') {
                    return postdate;
                }
                else {
                    let date = ("0" + inputDate.getDate()).slice(-2);
                    // current month
                    let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
                    // current year
                    let year = inputDate.getFullYear();
                    if (date.toString() == 'aN') {
                        return postdate;
                    }
                    else {
                        return date + "-" + month + "-" + year;
                    }
                }
            }
            else {
                return "";
            }
        },
        dateFormatYMD(inputDate) {
            var postdate = inputDate;
            if (inputDate) {
                inputDate = new Date(inputDate);
                if (inputDate.toString() == 'NaN-NaN-NaN') {
                    return postdate;
                }
                else {
                    let date = ("0" + inputDate.getDate()).slice(-2);
                    // current month
                    let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
                    // current year
                    let year = inputDate.getFullYear();
                    if (date.toString() == 'aN') {
                        return postdate;
                    }
                    else {
                        return year + "-" + month + "-" + date;
                    }
                }
            }
            else {
                return "";
            }
        },
        getDistanceFromLatLonInMeters(data) {
            var lat1 = data.visit_lat;
            var lon1 = data.visit_lng;
            var lat2 = data.stop_location.lat;
            var lon2 = data.stop_location.lng;
            if (data.visit_lat == 0 || data.visit_lng == 0) {
                return "0";
            }
            const earthRadius = 6371000; // Earth's radius in meters
            const deg2rad = (deg) => {
                return deg * (Math.PI / 180);
            };
            const dLat = deg2rad(lat2 - lat1);
            const dLon = deg2rad(lon2 - lon1);
            const a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            const distance = earthRadius * c;
            return distance.toFixed(2);
        },
        async getRideGroupStopData(id) {
            var data = { _id: id };
            var promise = apis.getRideGroupStopData(data);
            promise
                .then(response => {
                    if (response.data.data) {
                        var list = response.data.data;
                        for (let A = 0; A < list.length; A++) {
                            list[A]['distance'] = this.getDistanceFromLatLonInMeters(list[A]);
                        }
                        this.home_list = list;
                        this.original_home_list = list;
                        this.visited = 0;
                        this.total_stops = 0;
                        var stops_data = [];
                        this.total_stops = response.data.data.length;
                        for (let x = 0; x < response.data.data.length; x++) {
                            var icon = '';
                            if (response.data.data[x].status == 'visited') {
                                this.visited = this.visited + 1;
                                icon = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png';
                            } else {
                                icon = 'http://maps.google.com/mapfiles/ms/icons/red-dot.png';
                            }
                            stops_data.push({
                                lat: parseFloat(response.data.data[x].stop_location.lat),
                                lng: parseFloat(response.data.data[x].stop_location.lng),
                                'stop_name': response.data.data[x].stop_name,
                                icon: icon,
                                status: response.data.data[x].status
                            });
                        }
                        this.markers = stops_data;
                        this.original_marker_data = stops_data;
                    }
                });
        },
        hide(type = '') {
            if (type == 1) {
                this.polyline_show = false;
            }
            if (type == 2) {
                this.polyline_show = true;
            }
        },
        dateFormat(inputDate) {
            var postdate = inputDate;
            if (inputDate) {
                inputDate = new Date(inputDate);
                if (inputDate.toString() == 'NaN-NaN-NaN') {
                    return postdate;
                }
                else {
                    let date = ("0" + inputDate.getDate()).slice(-2);
                    // current month
                    let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
                    // current year
                    let year = inputDate.getFullYear();
                    if (date.toString() == 'aN') {
                        return postdate;
                    }
                    else {
                        return date + "-" + month + "-" + year;
                    }
                }
            }
            else {
                return "";
            }
        },
        async getRideMaster(id) {
            var data = { ride_id: id };
            var promise = apis.rideMaster(data);
            promise
                .then(response => {
                    if (response.data.data && response.data.data.length > 0) {
                        this.ride_details = response.data.data[0];
                        this.route_name = this.ride_details.group_name;
                        this.driver_photo = this.ride_details.driverdetails['profile_image'];
                        this.driver_name = this.ride_details.driverdetails['first_name'] + " " + this.ride_details.driverdetails['last_name'];
                        this.driver_mobile_number = this.ride_details.driverdetails['mobile_number'];
                        this.driver_mobile_number = this.ride_details.driverdetails['mobile_number'];
                        this.dl_number = this.ride_details.driverdetails['dldetails']['dl_number'];
                        this.dl_expiry_date = this.ride_details.driverdetails['dldetails']['dl_expiry_date'];
                        this.accidental_history = this.ride_details.driverdetails['dldetails']['accidental_history'];
                        this.available24by7 = this.ride_details.driverdetails['dldetails']['available24by7'];
                        this.shift_time_from = this.ride_details.driverdetails['dldetails']['shift_time_from'];
                        this.shift_time_to = this.ride_details.driverdetails['dldetails']['shift_time_to'];
                        if (this.ride_details.ownerdetails && this.ride_details.ownerdetails['first_name'] && this.ride_details.ownerdetails['last_name']) {
                            this.owner_name = this.ride_details.ownerdetails['first_name'] + " " + this.ride_details.ownerdetails['last_name'];
                            this.owner_mobile_number = this.ride_details.ownerdetails['mobile_number'];
                            this.owner_photo = this.ride_details.ownerdetails['profile_image'];
                        }
                        this.vehicle_registration_number = this.ride_details.vehicledetails['registration_number'];
                        this.vehicle_model = this.ride_details.vehicledetails['model'];
                        this.vehicle_type = this.ride_details.vehicledetails['vehicle_type'];
                        this.make_year = this.ride_details.vehicledetails['make_year'];
                        this.fitness_validity = this.ride_details.vehicledetails['fitness_validity'];
                        this.insurance_validity = this.ride_details.vehicledetails['insurance_validity'];
                        this.puc_validity = this.ride_details.vehicledetails['puc_validity'];
                        this.fuel_type = this.ride_details.vehicledetails['fuel_type'];
                        if (this.ride_details.vehicledetails['documents'].length > 0) {
                            this.vehicle_image = this.ride_details.vehicledetails['documents']['vehicle_photos'][0];
                        }
                    }
                });
        },
        // async view_Map(data) {
        //     await this.getRideMaster(data.ride_id);
        //     await this.getRideGroupStopData(data.ride_id);
        //     await this.getRideData(data.ride_id, 2);
        //     this.visited = 0;
        //     this.total_stops = 0;
        //     this.pending = true;
        //     this.visit = true;
        //     this.route_name = data.route_name;
        //     this.map_productDialog = true;
        // },
        reset() {
            this.vehicle_data = [];
            this.search_vehicle_data = [];
            this.vehicle_from_date = '';
            this.vehicle_to_date = '';
            this.client_id_search = '';
            this.vehicle_dropdownItem = '';
            this.routeitem_multiselect = '';
            this.reg_number = '';
            this.pending = true;
            this.visit = true;
            this.get_dashboard_vehicle_list(1);
        },
        get_select_vehicle_details(event) {
            var client_group_ids = [];
            if (localStorage.getItem('client_group_ids')) {
                client_group_ids = JSON.parse(localStorage.getItem('client_group_ids'));
            }
            else {
                client_group_ids.push(localStorage.getItem('client_id'));
            }
            //var client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];
            // var client_id = localStorage.getItem('client_id') ? localStorage.getItem('client_id'):[];
            if (this.client_id_search && this.client_id_search.length > 0) {
                client_group_ids = []
                for (let x = 0; x < this.client_id_search.length; x++) {
                    client_group_ids.push(this.client_id_search[x].value);
                }
            }
            var vehicle_type = [];
            if (this.vehicle_dropdownItem && this.vehicle_dropdownItem.length > 0) {
                for (let x = 0; x < this.vehicle_dropdownItem.length; x++) {
                    vehicle_type.push(this.vehicle_dropdownItem[x].value);
                }
            }
            var routeitem_multiselect_type = [];
            if (this.routeitem_multiselect && this.routeitem_multiselect.length > 0) {
                for (let x = 0; x < this.routeitem_multiselect.length; x++) {
                    routeitem_multiselect_type.push(this.routeitem_multiselect[x].value);
                }
            }
            var data = {
                "limit": this.limit,
                "page_no": this.page_no,
                "count": false,
                "client_group_ids": client_group_ids,
                //"client_id":client_id,
                "date": event.data.date,
                "vehicle_id": event.data.vehicle_id,
                "state_code": this.string_to_array_converter(localStorage.getItem('state_code')),
                "district_id": this.string_to_array_converter(localStorage.getItem('district_id')),
                "block_id": this.string_to_array_converter(localStorage.getItem('block_id')),
                "village_id": this.string_to_array_converter(localStorage.getItem('village_id')),
                "vehicle_number": this.reg_number,
                "vehicle_type": vehicle_type,
                "route_id": routeitem_multiselect_type
            };
            this.set_loading = true;
            var promise = apis.vehicleRideList(data, this.id);
            promise.then((response) => {
                this.set_loading = false;
                this.search_vehicle_data = response.data.data;
            });
        },
        get_vehicle_type_master() {
            var client_id = this.client_id_search.code ? this.client_id_search.code : localStorage.getItem("client_id");
            const client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')) : [];
            var data = {
                "client_group_ids": client_group_ids,
                client_id: client_id
            };
            var promise = apis.vehicle_type_master(data);
            promise.then((response) => {
                if (response.data.data) {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({
                            name: response.data.data[x].name, value: response.data.data[x].name
                        });
                    }
                    this.vehicle_dropdownItem = '';
                    this.vehicle_dropdownItems = temp_data;
                }
            });
        },
        string_to_array_converter(str) {
            if (str) {
                var substrings = str.split(",");
                var strArray = substrings.map(function (substring) {
                    return parseFloat(substring.trim());
                });
                return strArray;
            } else {
                return [];
            }
        },
        get_dashboard_vehicle_list(flag) {
            var from_date = '';
            var to_date = '';
            if (flag == 2) {
                //from_date=this.dateFormatYMD(this.vehicle_from_date);
                //to_date=this.dateFormatYMD(this.vehicle_to_date);
                from_date = this.dateFormatYMD(this.vehicle_from_date[0]);
                to_date = this.dateFormatYMD(this.vehicle_from_date[1]);
            }
            else {
                const { firstDate, lastDate } = this.getFirstAndLastDateOfCurrentMonth();
                //this.vehicle_from_date=new Date(firstDate);
                this.vehicle_from_date = [new Date(firstDate), new Date(lastDate)];
                //this.vehicle_to_date=new Date(lastDate);
                from_date = firstDate;
                to_date = lastDate;
            }
            // var client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];
            // var client_id = localStorage.getItem('client_id') ? localStorage.getItem('client_id'):[];
            var client_group_ids = [];
            if (localStorage.getItem('client_group_ids')) {
                client_group_ids = JSON.parse(localStorage.getItem('client_group_ids'));
            }
            else {
                client_group_ids.push(localStorage.getItem('client_id'));
            }
            if (this.client_id_search && this.client_id_search.length > 0) {
                client_group_ids = []
                for (let x = 0; x < this.client_id_search.length; x++) {
                    client_group_ids.push(this.client_id_search[x].value);
                }
            }
            var vehicle_type = [];
            if (this.vehicle_dropdownItem && this.vehicle_dropdownItem.length > 0) {
                for (let x = 0; x < this.vehicle_dropdownItem.length; x++) {
                    vehicle_type.push(this.vehicle_dropdownItem[x].value);
                }
            }
            var routeitem_multiselect_type = [];
            if (this.routeitem_multiselect && this.routeitem_multiselect.length > 0) {
                for (let x = 0; x < this.routeitem_multiselect.length; x++) {
                    routeitem_multiselect_type.push(this.routeitem_multiselect[x].value);
                }
            }
            var data = {
                "limit": this.limit,
                "page_no": this.page_no,
                "count": false,
                // "client_id":client_id,
                "client_group_ids": client_group_ids,
                "from_date": from_date,
                "to_date": to_date,
                "state_code": this.string_to_array_converter(localStorage.getItem('state_code')),
                "district_id": this.string_to_array_converter(localStorage.getItem('district_id')),
                "block_id": this.string_to_array_converter(localStorage.getItem('block_id')),
                "village_id": this.string_to_array_converter(localStorage.getItem('village_id')),
                vehicle_number: this.reg_number,
                "vehicle_type": vehicle_type,
                "route_id": routeitem_multiselect_type
            };
            this.loading = true;
            var promise = apis.vehiclelistDashboard(data, this.id);
            promise.then((response) => {
                this.loading = false;
                this.vehicle_data = [];
                this.search_vehicle_data = [];
                this.vehicle_data = response.data.data;
                if (this.vehicle_data.length > 0) {
                    this.vehicle_data.forEach((vehicle, index) => {
                        vehicle['sr_no'] = Math.random();
                    });
                }
            });
        },
        onRowSelect(event) {
            this.get_select_vehicle_details(event)
        },
        getFirstAndLastDateOfCurrentMonth() {
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = currentDate.getMonth();
            // Calculate the last day of the current month
            const lastDay = new Date(year, month + 1, 0).getDate();
            const firstDate = new Date(year, month, 1);
            const lastDate = new Date(year, month, lastDay);
            const formattedFirstDate = `${year}-${(month + 1).toString().padStart(2, '0')}-01`;
            const formattedLastDate = `${year}-${(month + 1).toString().padStart(2, '0')}-${lastDay.toString().padStart(2, '0')}`;
            return {
                firstDate: formattedFirstDate,
                lastDate: formattedLastDate
            };
        },
        toggleZoom() {
            this.isZoomed = !this.isZoomed;
        },
        toggleZoom1() {
            this.isZoomed1 = !this.isZoomed1;
        },
        setChartData1() {
            return {
                labels: ['Flat or faulty battery', 'Lost keys', 'Damaged tyres and wheels', 'Overheating', 'Fuel problems'],
                datasets: [
                    {
                        data: [540, 325, 702, 220, 84],
                        backgroundColor: ['#6366F1', '#EADA41', '#3DCC5B', 'black', '#FF5454'],
                        hoverBackgroundColor: ['#FF5454', 'pink', '#F77275', '#EADA41', '#3DCC5B']
                    }
                ]
            };
        },
        setChartData3() {
            return {
                labels: ['Battery Operated Garbage Vehicle', 'Garbage Cycle'],
                datasets: [
                    {
                        data: [28000, 12000],
                        backgroundColor: ['#EADA41', '#3DCC5B'],
                        hoverBackgroundColor: ['#F77275', 'pink']
                    }
                ]
            };
        },
        setChartData() {
            return {
                //labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                labels: ["1-6-2023", "2-6-2023", "3-6-2023", "4-6-2023", "5-6-2023", "6-6-2023", "7-6-2023", "8-6-2023", "9-6-2023", "10-6-2023", "11-6-2023", "12-6-2023", "13-6-2023", "14-6-2023", "15-6-2023", "16-6-2023", "17-6-2023", "18-6-2023", "19-6-2023", "20-6-2023", "21-6-2023", "22-6-2023", "23-6-2023", "24-6-2023", "25-6-2023", "26-6-2023", "27-6-2023", "28-6-2023", "29-6-2023", "30-6-2023"],
                datasets: [
                    {
                        type: 'bar',
                        label: 'Visited Home',
                        backgroundColor: '#173EA3',
                        data: [75000, 74058, 76889, 75894, 78215, 77854, 35000, 75000, 74058, 76889, 75894, 78215, 77854, 35000, 75000, 74058, 76889, 75894, 78215, 77854, 35000, 75000, 74058, 76889, 75894, 78215, 77854, 35000, 78124, 76982]
                    },
                    {
                        type: 'bar',
                        label: 'Total Homes',
                        backgroundColor: '#FF5454',
                        data: [100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000]
                    },
                ]
            };
        },
        setChartData2() {
            return {
                //labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                labels: ["1-6-2023", "2-6-2023", "3-6-2023", "4-6-2023", "5-6-2023", "6-6-2023", "7-6-2023", "8-6-2023", "9-6-2023", "10-6-2023", "11-6-2023", "12-6-2023", "13-6-2023", "14-6-2023", "15-6-2023", "16-6-2023", "17-6-2023", "18-6-2023", "19-6-2023", "20-6-2023", "21-6-2023", "22-6-2023", "23-6-2023", "24-6-2023", "25-6-2023", "26-6-2023", "27-6-2023", "28-6-2023", "29-6-2023", "30-6-2023"],
                datasets: [
                    {
                        type: 'bar',
                        label: 'Vehicle With Ride',
                        backgroundColor: '#173EA3',
                        data: [20101, 22201, 24521, 26121, 21254, 22654, 25212, 20101, 22201, 24521, 26121, 21254, 22654, 25212, 20101, 22201, 24521, 26121, 21254, 22654, 25212, 20101, 22201, 24521, 26121, 21254, 22654, 25212, 21254, 25487]
                    },
                    {
                        type: 'bar',
                        label: 'Total Vehicles',
                        backgroundColor: '#FF5454',
                        data: [40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000]
                    },
                ]
            };
        },
        setChartOptions() {
            //stackdata
            // return {
            //     maintainAspectRatio: false,
            //     aspectRatio: 0.8,
            //     plugins: {
            //         tooltips: {
            //             mode: 'index',
            //             intersect: false
            //         },
            //         legend: {
            //             labels: {
            //                 color: '#908fa8'
            //             }
            //         }
            //     },
            //     scales: {
            //         x: {
            //             stacked: true,
            //             ticks: {
            //                 color: '#908fa8'
            //             },
            //             grid: {
            //                 color: '#908fa8'
            //             }
            //         },
            //         y: {
            //             stacked: true,
            //             ticks: {
            //                 color: '#908fa8'
            //             },
            //             grid: {
            //                 color: '#908fa8'
            //             }
            //         }
            //     }
            // };
            return {
                maintainAspectRatio: false,
                aspectRatio: 0.8,
                plugins: {
                    legend: {
                        labels: {
                            fontColor: '#908fa8'
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#908fa8',
                            font: {
                                weight: 500
                            }
                        },
                        grid: {
                            display: false,
                            drawBorder: false
                        }
                    },
                    y: {
                        ticks: {
                            color: '#908fa8'
                        },
                        grid: {
                            color: '#908fa8',
                            drawBorder: false
                        }
                    }
                }
            };
        },
        setChartOptions2() {
            // return {
            //     maintainAspectRatio: false,
            //     aspectRatio: 0.8,
            //     plugins: {
            //         tooltips: {
            //             mode: 'index',
            //             intersect: false
            //         },
            //         legend: {
            //             labels: {
            //                 color: '#908fa8'
            //             }
            //         }
            //     },
            //     scales: {
            //         x: {
            //             stacked: true,
            //             ticks: {
            //                 color: '#908fa8'
            //             },
            //             grid: {
            //                 color: '#908fa8'
            //             }
            //         },
            //         y: {
            //             stacked: true,
            //             ticks: {
            //                 color: '#908fa8'
            //             },
            //             grid: {
            //                 color: '#908fa8'
            //             }
            //         }
            //     }
            // };
            return {
                maintainAspectRatio: false,
                aspectRatio: 0.8,
                plugins: {
                    legend: {
                        labels: {
                            fontColor: '#908fa8'
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#908fa8',
                            font: {
                                weight: 500
                            }
                        },
                        grid: {
                            display: false,
                            drawBorder: false
                        }
                    },
                    y: {
                        ticks: {
                            color: '#908fa8'
                        },
                        grid: {
                            color: '#908fa8',
                            drawBorder: false
                        }
                    }
                }
            };
        },
        setChartData_doughnut() {
            const documentStyle = getComputedStyle(document.body);
            return {
                labels: ['Completed', 'In-progress', 'Not Started'],
                datasets: [
                    {
                        data: [2540, 1540, 2122],
                        backgroundColor: [documentStyle.getPropertyValue('--blue-500'), documentStyle.getPropertyValue('--yellow-500'), documentStyle.getPropertyValue('--green-500')],
                        hoverBackgroundColor: [documentStyle.getPropertyValue('--blue-400'), documentStyle.getPropertyValue('--yellow-400'), documentStyle.getPropertyValue('--green-400')]
                    }
                ]
            };
        },
        getaltimage() {
            return "https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o=";
        },
        reset_search_people() {
            this.search_key = '';
            this.name = '';
            this.city = '';
            this.state = '';
            this.pincode = '';
            this.vehicle_number = '';
            this.routeitem = '';
            this.client_id_search = '';
        },
        search_people() {
            if (this.search_key || this.name || this.city || this.state || this.pincode || this.vehicle_number || this.routeitem.value || this.client_id_search.value) {
                // alert(1);
                this.gettodaysTravelList();
            }
        },
        uniqueAssociativeArray(array) {
            let uniqueArray = {};
            for (let i = 0; i < array.length; i++) {
                let currentElement = array[i];
                if (!uniqueArray[currentElement]) {
                    uniqueArray[currentElement] = true;
                }
            }
            return Object.keys(uniqueArray);
        },
        filterAssociativeArray(arr, key, values) {
            var result = arr.filter(function (a) {
                return values.indexOf(a[key]) !== -1;
            });
            return result;
        },
        gettodaysTravelList() {
            const client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')) : [];
            this.isLoadingModel = true;
            var data = {
                "route_id": this.routeitem.value,
                //"search_client":this.client_id_search.value,
                "mobile_number": this.search_key,
                "city": this.city,
                "pincode": this.pincode,
                "state": this.state,
                "vehicle_number": this.vehicle_number,
                "name": this.name,
                "client_group_ids": client_group_ids,
                "client_id": this.client_id_search.value ? this.client_id_search.value : localStorage.getItem("client_id")
            }
            var promise = apis.todaysTravelListDashboard(data);
            promise
                .then(response => {
                    // alert(1);
                    this.isLoadingModel = false;
                    this.travellist = response.data.data;
                    for (var i = 0; i < this.travellist.length; i++) {
                        this.travellist[i].lat = parseFloat(this.travellist[i].lat);
                        this.travellist[i].lng = parseFloat(this.travellist[i].lng);
                    }
                    this.travellist_filter = this.travellist;
                }).catch((error) => {
                    //console.log(error);
                    this.isLoadingModel = false;
                    // this.$swal.fire(error.response.data);
                })
                ;
        },
        submitMessage() {
            const CHAT_ROOM = this.form.roomName;
            const message = this.inputMessageText;
            SocketioService.sendMessage({ message, roomName: CHAT_ROOM }, (cb) => {
                console.log(cb);
                this.messages.push({
                    message,
                    ...SENDER,
                });
                // clear the input after the message is sent
                this.inputMessageText = "";
            });
        },
        async submitToken() {
            console.log("inside submit token");
            let header = {
                "Access-Control-Allow-Origin": "*",
                "content-type": "application/json",
            };
            let Promise = axios.post("http://65.1.73.254:8090/", this.form, {
                header: header,
            });
            Promise.then((res) => {
                if (res.status == 200) {
                    //console.log(res);
                    this.token = res.data.token;
                    
                    SocketioService.setupSocketConnection(this.token);
                    SocketioService.subscribeToMessages((err, data) => {
                       // console.log("position data", data);
                        this.messages.push(data);
                        console.log("socket position receive data ",data);
                        //data = JSON.parse(data);
                        
                        
                        
                        this.center1 = { "lat": data.lat, "lng": data.lng };
                        this.car_marker = { "lat": data.lat, "lng": data.lng };
                        this.polyline.push(this.center1);
                        this.refreshKey++;
                        localStorage.setItem('polyline', this.polyline);
                        
                        this.random = this.random + 1;
                        this.live_polypath = {
                            path: this.polyline,
                            geodesic: true,
                            strokeColor: 'blue',
                            strokeOpacity: 0.5,
                            strokeWeight: 5,
                        }
                    });
                }
            });
        },
        get_pending_alert_count() {
            var data = {
                id: localStorage.getItem("id"),
                count: true,
                unread: false,
                mobile_number: '',
                status: 0,
                from_date: new Date().toISOString().split('T')[0],
                to_date: new Date().toISOString().split('T')[0],
                type: "ride sos alert",
                client_id: localStorage.getItem("client_id")
            };
            var promise = apis.sosAlertMaster(data);
            promise.then((response) => {
                console.log(response);
                this.dashcount.pending_alerts = response.data.data;
            });
        },
        getRandNumber() {
            var x = Math.floor((Math.random() * 214) + 1); // get new random number
            if (x === this.lastNumber) { // compare with last number
                return this.getRandNumber() // if they are the same, call the function again to repeat the process
            }
            return x // if they're not the same, return it
        },
        getRideData(id, flag) {
            var data = { ride_id: id, speed: true };
            var promise = '';
            this.list_loader = true;
            if (flag == 1) {
                promise = apis.getRideDataLive(data);
            } else if (flag == 2) {
                promise = apis.get_RideDataHistory(data);
            }
            else {
                return false;
            }
            promise
                .then(response => {
                    this.list_loader = false;
                    this.list = [];
                    var speed_exceed = [];
                    this.list = response.data.data;
                    speed_exceed = response.data.speed_exceed;
                    if (speed_exceed.length > 0) {
                        var speed_data = [];
                        for (let x = 0; x < speed_exceed.length; x++) {
                            if (speed_exceed[x].lat && speed_exceed[x].lng && speed_exceed[x].speed > 1) {
                                speed_data.push({ lat: parseFloat(speed_exceed[x].lat), lng: parseFloat(speed_exceed[x].lng) });
                            }
                        }
                        this.speed_marker = speed_data;
                        this.original_speed_marker = speed_data;
                    }
                    if (flag == 1 && this.list.length == 0) {
                        this.getRideData(id, 2);
                        return false;
                    }
                    if (this.list.length > 0) {
                        if (flag == 1) {
                            this.total_distance = response.data.distance;
                            this.total_time = response.data.ride_time;
                            var length = this.list.length;
                            this.center = { lat: parseFloat(this.list[0].lat), lng: parseFloat(this.list[0].lng) };
                            // console.log("🚀 ~ file: TrackDashboard.vue:2912 ~ getRideData flag1 ~ this.center:", this.center)
                            this.center1 = { lat: parseFloat(this.list[length - 1].lat), lng: parseFloat(this.list[length - 1].lng) };
                            this.car_marker = { lat: parseFloat(this.list[length - 1].lat), lng: parseFloat(this.list[length - 1].lng) };
                            var data = [];
                            for (let x = 0; x < length; x++) {
                                if (this.list[x].lat && this.list[x].lng) {
                                    data.push({ lat: parseFloat(this.list[x].lat), lng: parseFloat(this.list[x].lng) });
                                }
                            }
                            //this.polypath = {path:data}
                            this.polypath = {
                                path: data,
                                geodesic: true,
                                strokeColor: 'blue',
                                strokeOpacity: 0.5,
                                strokeWeight: 5,
                            }
                            console.log("🚀 ~ file: TrackDashboard.vue:2951 ~ getRideData ~ this.polypath :", this.polypath)
                        }
                        else if (flag == 2) {
                            this.total_distance = response.data.distance;
                            this.total_time = response.data.ride_time;
                            var vehicle_length = this.list.length;
                            this.center = { lat: parseFloat(this.list[0].lat), lng: parseFloat(this.list[0].lng) };
                            // console.log("🚀 ~ file: TrackDashboard.vue:2912 ~ getRideData flag2 ~ this.center:", this.center)
                            this.center1 = { lat: parseFloat(this.list[vehicle_length - 1].lat), lng: parseFloat(this.list[vehicle_length - 1].lng) };
                            this.car_marker = { lat: parseFloat(this.list[vehicle_length - 1].lat), lng: parseFloat(this.list[vehicle_length - 1].lng) };
                            var vehicle_map_data = [];
                            for (let x = 0; x < vehicle_length; x++) {
                                if (this.list[x].lat && this.list[x].lng) {
                                    vehicle_map_data.push({ lat: parseFloat(this.list[x].lat), lng: parseFloat(this.list[x].lng) });
                                }
                            }
                            //this.polypath = {path:vehicle_map_data}
                            this.polypath = {
                                path: vehicle_map_data,
                                geodesic: true,
                                strokeColor: 'blue',
                                strokeOpacity: 0.5,
                                strokeWeight: 5,
                            }
                        }
                    }
                    // else
                    // {
                    //     this.center={ lat: 0, lng: 0 };
                    //     this.center1={lat: 0, lng: 0 };
                    // }
                }
                )
        },
        async refresh()
        {
           await this.view_details(this.location);
        },
        async view_details(location) {
            this.location=[];
            this.location=location;
            await this.getRideMaster(location._id);
            await this.getRideGroupStopData(location._id);
            await this.getRideData(location._id, 1);
            this.pending = true;
            this.visit = true;
            this.route_name = location.group_name;
            this.map_productDialog = true;
      
            //console.log(123, await this.getRandNumber());
            this.centerstart = { lat: location.lat, lng: location.lng }
            this.form.roomName = location.user_id;
            this.form.userName = location.user_id;
           
           // await this.submitToken();
         
        },
        back_map() {
            this.home = true;
            socketioService.disconnect();
        },
        show_route() {
            var screensize = document.querySelectorAll("#maph")
            screensize[0].style.display = "none";
            screensize[0].style.display = "block";
            this.show_map = false;
            this.show_map = true;
            this.home = true;
            this.home = false;
        },
        get_location_details(location) {
            // alert(location.name)
        },
        setupLeafletMap: function () {
            const mapDiv = L.map("mapContainer").setView([37, 7749, -122, 4194], 13);
            L.tileLayer(
                "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
                {
                    attribution:
                        'Map data (c) <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery (c) <a href="https://www.mapbox.com/">Mapbox</a>',
                    maxZoom: 18,
                    id: "mapbox/streets-v11",
                    token: "sk.eyJ1IjoicHJhdGhhbWVzaDExMDkiLCJhIjoiY2xidzBzZnVxMXB4ODNwcWRkOGRqOGluaiJ9.4K08iC1KLCqL6MOFcioywg",
                }
            ).addTo(mapDiv);
        },
        // load_map() {
        //     // let btn = document.getElementById('map');
        //     map = '';
        //     var map = new MapmyIndia.Map("map", { center: [28.09, 78.3], zoom: 5, search: false });
        // },
        go_to_user_route() {
            this.$router.push('/groupmaster');
        },
        go_to_driver() {
            this.$router.push('/usermaster');
            localStorage.driver = 'Driver';
        },
        go_to_vehicle() {
            this.$router.push('/vehiclemaster');
        },
        goto_alert() {
            this.$router.push('/sosalertmaster');
            localStorage.alert = 'alert';
        },
        go_to_rider() {
            this.$router.push('/ridemaster');
        },
        go_to_route() {
            this.$router.push('/groupmaster');
        },
        go_to_subject() {
            this.$router.push('/usermaster');
        },
        go_to_Notice() {
            this.$router.push('/NoticeMaster');
        },
        //-----------------------------------
        route_list() {
            var client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')) : [];
            if (this.client_id_search && this.client_id_search.length > 0) {
                client_group_ids = []
                for (let x = 0; x < this.client_id_search.length; x++) {
                    client_group_ids.push(this.client_id_search[x].value);
                }
            }
            var data = {
                count: false,
                "client_group_ids": client_group_ids,
                "client_id": this.client_id_search.value ? this.client_id_search.value : localStorage.getItem("client_id"),
                //"user_id":this.user_id
            };
            //this.loading = true;
            var promise = apis.group_list(data, this.id);
            promise.then((response) => {
                //this.loading = false;
                if (response.data.data.length > 0) {
                    response.data.data
                        .filter(item => item.name)
                        .map(item => this.routeitems.push({ name: item.name, value: item._id }));
                }
            });
        },
        get_client_list() {
            const client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')) : [];
            var data = { count: false };
            var promise = apis.getclientist(data);
            promise.then((response) => {
                // if (response.data.data) {
                //     response.data.data
                //         .filter(item => item.client_name)
                //         .map(item => this.client_id_dropdown.push({ name: item.client_name, value: item._id }));
                // }
                var temp_data = [];
                for (let x = 0; x < response.data.data.length; x++) {
                    const clientData = response.data.data[x];
                    if (clientData.client_name && (client_group_ids.length === 0 || client_group_ids.includes(clientData._id))) {
                        temp_data.push({ name: clientData.client_name, value: clientData._id });
                    }
                }
                this.client_id_dropdown = temp_data;
            });
        },
        async dashboardRideData() {
            var data = { client_id: localStorage.getItem("client_id") ? localStorage.getItem("client_id") : '' };
            var promise = apis.dashboardRideData(data);
            promise
                .then(response => {
                    this.barData.labels = response.data.data.series;
                    this.barData.datasets[0].data = response.data.data.data;
                });
        },
        async dashboardcount() {
            var data = { client_id: localStorage.getItem("client_id") ? localStorage.getItem("client_id") : '' };
            var promise = apis.clientDashboard(data);
            promise
                .then(response => {
                    var other_data = response.data.other_data;
                    this.dashcount.today_travels = other_data.todays_travel;
                    this.dashcount.travels = other_data.total_travel;
                    this.dashcount.schools = other_data.schools;
                    this.dashcount.school_buses = other_data.school_buses;
                    this.dashcount.alerts = other_data.alerts;
                    this.dashcount.today_alerts = other_data.todays_alerts;
                    this.dashcount.vehicles = other_data.vehicles;
                    this.dashcount.routes = other_data.routes;
                    this.dashcount.stops = other_data.stops || 0;
                    var data = response.data.data;
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].user_type == 'Driver') {
                            this.dashcount.drivers += data[i].count;
                        }
                        if (data[i].user_type == 'Owner') {
                            this.dashcount.owners += data[i].count;
                        }
                        if (data[i].user_type == 'Rider') {
                            this.dashcount.riders += data[i].count;
                        }
                        if (data[i].user_type == 'Driver Owner') {
                            this.dashcount.driverowner = data[i].count;
                        }
                        if (data[i].user_type == 'Admin') {
                            this.dashcount.admin = data[i].count;
                        }
                    }
                    // if(i==(count-1))
                    // {
                    // alert('here');
                    // alert(this.dashcount.riders);
                    // alert(i);
                    this.dashcount.alerts = response.data.other_data.alerts;
                    this.dashcount.today_alerts = response.data.other_data.todays_alerts;
                    this.pieData = {
                        labels: response.data.other_data.user_counts.labels,
                        datasets: [
                            {
                                data: response.data.other_data.user_counts.series_data,
                                backgroundColor: [
                                    "#F04136",
                                    "#2B3890",
                                    "#F7941E",
                                    "#F9ED32",
                                    "#D7F422",
                                    "#DE6BBC",
                                    "#DEDD59",
                                    "#58DEDF"
                                ],
                                hoverBackgroundColor: [
                                    "#FF6384",
                                    "#36A2EB",
                                    "#FFCE56",
                                    "#662D91",
                                    "#F8F194",
                                    "#58DEDF",
                                    "#949597",
                                    "#F8F194"
                                ]
                            }
                        ]
                    };
                    this.pieData1 = {
                        labels: response.data.other_data.vehicle_group.labels,
                        datasets: [
                            {
                                data: response.data.other_data.vehicle_group.series_data,
                                backgroundColor: [
                                    "#F04136",
                                    "#2B3890",
                                    "#F7941E",
                                    "#39B54A",
                                    "#D7F422",
                                    "#DE6BBC",
                                    "#DEDD59",
                                    "#58DEDF"
                                ],
                                hoverBackgroundColor: [
                                    "#FF6384",
                                    "#36A2EB",
                                    "#FFCE56",
                                    "#662D91",
                                    "#F8F194",
                                    "#58DEDF",
                                    "#949597",
                                    "#DEDD59"
                                ]
                            }
                        ]
                    };
                    // }
                    // this.dashcount=response.data;
                });
        },
        networkconnectivityreport() {
            var D = new Date(this.get_date_2);
            if (this.get_date_2) {
                var date = D.toLocaleDateString("en-US", { year: "numeric" }) + "-" + D.toLocaleDateString("en-US", { month: "2-digit" }) + "-" + D.toLocaleDateString("en-US", { day: "2-digit" });
            }
            var data = { date: date };
            var promise = apis.networkconnectivityreport(data);
            promise
                .then(response => {
                    this.lineData.datasets[0].data = Object.values(response.data);
                });
        },
        datausagereport() {
            var D = new Date(this.get_date);
            if (this.get_date) {
                var date = D.toLocaleDateString("en-US", { year: "numeric" }) + "-" + D.toLocaleDateString("en-US", { month: "2-digit" }) + "-" + D.toLocaleDateString("en-US", { day: "2-digit" });
            }
            var data = { date: date };
            var promise = apis.dashboarddatausagereport(data);
            promise
                .then(response => {
                    // alert(1);
                    // console.log(this.barData.datasets[0].data);
                    this.barData.datasets[0].data = Object.values(response.data);
                });
        },
        teacherlecturereportadmin() {
            var promise = apis.teacherlecturereportadmin();
            promise
                .then(response => {
                    // alert(1);
                    // console.log(this.barData.datasets[0].data);
                    this.barData1.labels = response.data.teacher;
                    this.barData1.datasets[0].data = response.data.lectures;
                });
        },
        todayslecturereport() {
            var data = {
                "limit": 5,
                "page_no": 1
            }
            var promise = apis.todayslecturereport(data);
            promise
                .then(response => {
                    // alert(1);
                    // console.log(this.barData.datasets[0].data);
                    this.todayslectures = response.data;
                });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        isDarkTheme() {
            return this.$appState.darkTheme === true;
        },
        applyLightTheme() {
            this.barOptions = {
                plugins: {
                    legend: {
                        labels: {
                            color: '#495057'
                        }
                    },
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef',
                        }
                    },
                    y: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef',
                        }
                    },
                }
            };
            this.barOptions1 = {
                indexAxis: 'y',
                plugins: {
                    legend: {
                        labels: {
                            color: '#495057'
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef',
                        }
                    },
                    y: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef',
                        }
                    },
                }
            };
            this.lineOptions = {
                plugins: {
                    legend: {
                        labels: {
                            color: '#495057'
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef',
                        }
                    },
                    y: {
                        ticks: {
                            color: '#495057'
                        },
                        grid: {
                            color: '#ebedef',
                        }
                    },
                }
            };
        },
        applyDarkTheme() {
            this.lineOptions = {
                plugins: {
                    legend: {
                        labels: {
                            color: '#ebedef'
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#ebedef'
                        },
                        grid: {
                            color: 'rgba(160, 167, 181, .3)',
                        }
                    },
                    y: {
                        ticks: {
                            color: '#ebedef'
                        },
                        grid: {
                            color: 'rgba(160, 167, 181, .3)',
                        }
                    },
                }
            };
        }
    },
    components: {
        Tabs,
        Tab,
        TabPanels,
        superset_dashboard,
        gps,
        GoogleMapDashboard,
        TabPanel,
        GoogleMap, Marker, MarkerCluster, InfoWindow, Polyline, GoogleMapComponent,
        "l-map": LMap,
        LTileLayer,
        LMarker,
        VueGauge,
        solid_waste,
        plastic,
        fical,
        QrcodeVue,
        DeliveryChallan,
        Track_Summary,
        Track_Gallary,
        IRChallan
        //DashboardComponent
    }
}
</script>
<style>
/* .layout-topbar,.layout-sidebar{ */
/* background-color:#173EA3 !important;
  }
  .layout-topbar .layout-topbar-button{
    color: white;
  }
  .layout-menu li a{
    color: white;
  }
  .layout-topbar-logo a{
    color: white;
  } */
/* .layout-main-container{
      background-color: black !important;
  }
  .layout-wrapper{
      background-color: black !important;
  } */
</style>
<style scoped>
#mapContainer {
    width: 100%;
    height: 100vh;
}

.p-button-sm {
    font-size: 0.7rem;
    padding: 0.4rem 0.8rem;
}

.bell {
    display: block;
    /* width: 40px;
  height: 40px; */
    /* font-size: 40px; */
    /* margin:50px auto 0; */
    color: #9e9e9e;
    -webkit-animation: ring 4s .7s ease-in-out infinite;
    -webkit-transform-origin: 50% 4px;
    -moz-animation: ring 4s .7s ease-in-out infinite;
    -moz-transform-origin: 50% 4px;
    animation: ring 4s .2s ease-in-out infinite;
    transform-origin: 50% 4px;
}

@-webkit-keyframes ring {
    0% {
        -webkit-transform: rotateZ(0);
    }

    1% {
        -webkit-transform: rotateZ(30deg);
    }

    3% {
        -webkit-transform: rotateZ(-28deg);
    }

    5% {
        -webkit-transform: rotateZ(34deg);
    }

    7% {
        -webkit-transform: rotateZ(-32deg);
    }

    9% {
        -webkit-transform: rotateZ(30deg);
    }

    11% {
        -webkit-transform: rotateZ(-28deg);
    }

    13% {
        -webkit-transform: rotateZ(26deg);
    }

    15% {
        -webkit-transform: rotateZ(-24deg);
    }

    17% {
        -webkit-transform: rotateZ(22deg);
    }

    19% {
        -webkit-transform: rotateZ(-20deg);
    }

    21% {
        -webkit-transform: rotateZ(18deg);
    }

    23% {
        -webkit-transform: rotateZ(-16deg);
    }

    25% {
        -webkit-transform: rotateZ(14deg);
    }

    27% {
        -webkit-transform: rotateZ(-12deg);
    }

    29% {
        -webkit-transform: rotateZ(10deg);
    }

    31% {
        -webkit-transform: rotateZ(-8deg);
    }

    33% {
        -webkit-transform: rotateZ(6deg);
    }

    35% {
        -webkit-transform: rotateZ(-4deg);
    }

    37% {
        -webkit-transform: rotateZ(2deg);
    }

    39% {
        -webkit-transform: rotateZ(-1deg);
    }

    41% {
        -webkit-transform: rotateZ(1deg);
    }

    43% {
        -webkit-transform: rotateZ(0);
    }

    100% {
        -webkit-transform: rotateZ(0);
    }
}

@-moz-keyframes ring {
    0% {
        -moz-transform: rotate(0);
    }

    1% {
        -moz-transform: rotate(30deg);
    }

    3% {
        -moz-transform: rotate(-28deg);
    }

    5% {
        -moz-transform: rotate(34deg);
    }

    7% {
        -moz-transform: rotate(-32deg);
    }

    9% {
        -moz-transform: rotate(30deg);
    }

    11% {
        -moz-transform: rotate(-28deg);
    }

    13% {
        -moz-transform: rotate(26deg);
    }

    15% {
        -moz-transform: rotate(-24deg);
    }

    17% {
        -moz-transform: rotate(22deg);
    }

    19% {
        -moz-transform: rotate(-20deg);
    }

    21% {
        -moz-transform: rotate(18deg);
    }

    23% {
        -moz-transform: rotate(-16deg);
    }

    25% {
        -moz-transform: rotate(14deg);
    }

    27% {
        -moz-transform: rotate(-12deg);
    }

    29% {
        -moz-transform: rotate(10deg);
    }

    31% {
        -moz-transform: rotate(-8deg);
    }

    33% {
        -moz-transform: rotate(6deg);
    }

    35% {
        -moz-transform: rotate(-4deg);
    }

    37% {
        -moz-transform: rotate(2deg);
    }

    39% {
        -moz-transform: rotate(-1deg);
    }

    41% {
        -moz-transform: rotate(1deg);
    }

    43% {
        -moz-transform: rotate(0);
    }

    100% {
        -moz-transform: rotate(0);
    }
}

@keyframes ring {
    0% {
        transform: rotate(0);
    }

    1% {
        transform: rotate(30deg);
    }

    3% {
        transform: rotate(-28deg);
    }

    5% {
        transform: rotate(34deg);
    }

    7% {
        transform: rotate(-32deg);
    }

    9% {
        transform: rotate(30deg);
    }

    11% {
        transform: rotate(-28deg);
    }

    13% {
        transform: rotate(26deg);
    }

    15% {
        transform: rotate(-24deg);
    }

    17% {
        transform: rotate(22deg);
    }

    19% {
        transform: rotate(-20deg);
    }

    21% {
        transform: rotate(18deg);
    }

    23% {
        transform: rotate(-16deg);
    }

    25% {
        transform: rotate(14deg);
    }

    27% {
        transform: rotate(-12deg);
    }

    29% {
        transform: rotate(10deg);
    }

    31% {
        transform: rotate(-8deg);
    }

    33% {
        transform: rotate(6deg);
    }

    35% {
        transform: rotate(-4deg);
    }

    37% {
        transform: rotate(2deg);
    }

    39% {
        transform: rotate(-1deg);
    }

    41% {
        transform: rotate(1deg);
    }

    43% {
        transform: rotate(0);
    }

    100% {
        transform: rotate(0);
    }
}

.active {
    /* background-color: #22C55E; */
    border-bottom: 4px solid #22C55E;
    /* Change this to your desired color */
    color: black;
    /* Text color for active tab */
    /* border-radius: 10px; */
    font-weight: bold;
}
.tab:hover {
  font-weight: bold;
  border-bottom: 4px solid #22C55E;
}
.inactive {
    /* background-color: #374151; */
    /* Change this to your desired color */
    color: black;
    /* Text color for inactive tab */
    /* border-radius: 10px; */
    /* font-weight: bold; */
}

.card {
    cursor: pointer;
}</style>